import { useEffect, useState, useRef, useCallback } from "react";
import ReactQuill, { Quill } from "react-quill";

import {
  deleteData,
  fetchData,
  postData,
  putData,
  putFormData,
  postFormData,
} from "../../../endpoints";
import {
  Button,
  Spin,
  Modal,
  Form,
  Input,
  Select,
  Tag,
  Table,
  Space,
} from "antd";
import { FileUploader } from "react-drag-drop-files";
import { CustomInput } from "../../../components/CustomInput";
import {
  ExclamationCircleFilled,
  MoreOutlined,
  NodeExpandOutlined,
  CaretDownOutlined,
} from "@ant-design/icons";
import { useMobile } from "../../../hooks";
import ChatBubbles from "./chatbubble";
import FormItem from "antd/es/form/FormItem";
import access from "../../../assets/access";
import Cookies from "js-cookie";
import full from "../../../assets/fullAccess";
import { render } from "react-dom";
import CommentCard from "../../ToDo/comment/commentCard";
import AddComment from "../../ToDo/comment/addComment";
import { redirect, useLocation } from "react-router-dom";
import { useConfig } from "../../../hooks/useConfig";
const privilage = Cookies.get("privilege") ?? full;

const statusList = {
  active: {
    name: "",
    icon: (
      <svg
        width="32"
        height="32"
        viewBox="0 0 32 32"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <circle cx="16" cy="16" r="15" stroke="#279BD6" stroke-width="2" />
        <mask id="path-2-inside-1_502_7167" fill="white">
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M16 27C22.0748 27 27 22.0748 27 16C27 9.92525 22.0748 5 16 5C9.92525 5 5 9.92525 5 16C5 22.0748 9.92525 27 16 27ZM16 21C18.7612 21 21 18.7612 21 16C21 13.2388 18.7612 11 16 11C13.2388 11 11 13.2388 11 16C11 18.7612 13.2388 21 16 21Z"
          />
        </mask>
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M16 27C22.0748 27 27 22.0748 27 16C27 9.92525 22.0748 5 16 5C9.92525 5 5 9.92525 5 16C5 22.0748 9.92525 27 16 27ZM16 21C18.7612 21 21 18.7612 21 16C21 13.2388 18.7612 11 16 11C13.2388 11 11 13.2388 11 16C11 18.7612 13.2388 21 16 21Z"
          fill="#279BD6"
        />
        <path
          d="M25 16C25 20.9702 20.9702 25 16 25V29C23.1793 29 29 23.1793 29 16H25ZM16 7C20.9702 7 25 11.0298 25 16H29C29 8.82068 23.1793 3 16 3V7ZM7 16C7 11.0298 11.0298 7 16 7V3C8.82068 3 3 8.82068 3 16H7ZM16 25C11.0298 25 7 20.9702 7 16H3C3 23.1793 8.82068 29 16 29V25ZM19 16C19 17.6567 17.6567 19 16 19V23C19.8658 23 23 19.8658 23 16H19ZM16 13C17.6567 13 19 14.3433 19 16H23C23 12.1342 19.8658 9 16 9V13ZM13 16C13 14.3433 14.3433 13 16 13V9C12.1342 9 9 12.1342 9 16H13ZM16 19C14.3433 19 13 17.6567 13 16H9C9 19.8658 12.1342 23 16 23V19Z"
          fill="#279BD6"
          mask="url(#path-2-inside-1_502_7167)"
        />
      </svg>
    ),
    backgroundColor: "linear-gradient(to right, #00E0EE , #028BC6)",
    color: "rgba(2, 139, 198, 1)",
  },
  is_scheduled: {
    name: "",
    icon: (
      <svg
        width="32"
        height="32"
        viewBox="0 0 32 32"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <circle
          cx="16"
          cy="16"
          r="15"
          stroke="url(#paint0_radial_1323_14866)"
          stroke-width="2"
        />
        <path
          d="M16 5C13.8244 5 11.6977 5.64514 9.88873 6.85383C8.07979 8.06253 6.66989 9.78049 5.83733 11.7905C5.00477 13.8005 4.78693 16.0122 5.21137 18.146C5.6358 20.2798 6.68345 22.2398 8.22183 23.7782C9.76021 25.3165 11.7202 26.3642 13.854 26.7886C15.9878 27.2131 18.1995 26.9952 20.2095 26.1627C22.2195 25.3301 23.9375 23.9202 25.1462 22.1113C26.3549 20.3023 27 18.1756 27 16C26.9969 13.0836 25.837 10.2875 23.7747 8.22527C21.7125 6.16305 18.9164 5.00312 16 5ZM8.14286 16.7857H7.35715C7.14876 16.7857 6.94891 16.7029 6.80156 16.5556C6.65421 16.4082 6.57143 16.2084 6.57143 16C6.57143 15.7916 6.65421 15.5918 6.80156 15.4444C6.94891 15.2971 7.14876 15.2143 7.35715 15.2143H8.14286C8.35125 15.2143 8.5511 15.2971 8.69845 15.4444C8.8458 15.5918 8.92858 15.7916 8.92858 16C8.92858 16.2084 8.8458 16.4082 8.69845 16.5556C8.5511 16.7029 8.35125 16.7857 8.14286 16.7857ZM10.9997 22.1113L10.4442 22.6668C10.296 22.8099 10.0976 22.8891 9.89154 22.8873C9.68553 22.8855 9.48847 22.8029 9.34279 22.6572C9.19711 22.5115 9.11448 22.3145 9.11269 22.1085C9.1109 21.9024 9.19009 21.704 9.33322 21.5558L9.88872 21.0003C10.0369 20.8572 10.2354 20.778 10.4414 20.7798C10.6474 20.7815 10.8445 20.8642 10.9901 21.0099C11.1358 21.1555 11.2185 21.3526 11.2202 21.5586C11.222 21.7646 11.1428 21.9631 10.9997 22.1113ZM10.9997 10.9997C10.8524 11.147 10.6526 11.2298 10.4442 11.2298C10.2359 11.2298 10.0361 11.147 9.88872 10.9997L9.33322 10.4442C9.19009 10.296 9.1109 10.0976 9.11269 9.89154C9.11448 9.68553 9.19711 9.48846 9.34279 9.34278C9.48847 9.19711 9.68553 9.11447 9.89154 9.11268C10.0976 9.11089 10.296 9.19009 10.4442 9.33321L10.9997 9.88871C11.147 10.0361 11.2298 10.2359 11.2298 10.4442C11.2298 10.6526 11.147 10.8524 10.9997 10.9997ZM16.7857 24.6429C16.7857 24.8512 16.7029 25.0511 16.5556 25.1984C16.4082 25.3458 16.2084 25.4286 16 25.4286C15.7916 25.4286 15.5918 25.3458 15.4444 25.1984C15.2971 25.0511 15.2143 24.8512 15.2143 24.6429V23.8571C15.2143 23.6488 15.2971 23.4489 15.4444 23.3016C15.5918 23.1542 15.7916 23.0714 16 23.0714C16.2084 23.0714 16.4082 23.1542 16.5556 23.3016C16.7029 23.4489 16.7857 23.6488 16.7857 23.8571V24.6429ZM16.7857 16C16.7857 16.1293 16.7538 16.2566 16.6928 16.3707C16.6318 16.4847 16.5437 16.5819 16.4361 16.6537L14.0789 18.2251C13.9056 18.3408 13.6933 18.3828 13.489 18.342C13.2846 18.3012 13.1048 18.1809 12.9891 18.0075C12.8735 17.8341 12.8314 17.6219 12.8723 17.4175C12.9131 17.2132 13.0334 17.0334 13.2068 16.9177L14.3235 16.1734C14.88 15.8024 15.2143 15.1779 15.2143 14.5092V11.2857C15.2143 11.0773 15.2971 10.8775 15.4444 10.7301C15.5918 10.5828 15.7916 10.5 16 10.5C16.2084 10.5 16.4082 10.5828 16.5556 10.7301C16.7029 10.8775 16.7857 11.0773 16.7857 11.2857V16ZM16.7857 8.14286C16.7857 8.35124 16.7029 8.55109 16.5556 8.69844C16.4082 8.84579 16.2084 8.92857 16 8.92857C15.7916 8.92857 15.5918 8.84579 15.4444 8.69844C15.2971 8.55109 15.2143 8.35124 15.2143 8.14286V7.35714C15.2143 7.14876 15.2971 6.94891 15.4444 6.80156C15.5918 6.65421 15.7916 6.57143 16 6.57143C16.2084 6.57143 16.4082 6.65421 16.5556 6.80156C16.7029 6.94891 16.7857 7.14876 16.7857 7.35714V8.14286ZM22.6668 22.6668C22.5194 22.8141 22.3196 22.8968 22.1113 22.8968C21.9029 22.8968 21.7031 22.8141 21.5558 22.6668L21.0003 22.1113C20.8572 21.9631 20.778 21.7646 20.7798 21.5586C20.7815 21.3526 20.8642 21.1555 21.0099 21.0099C21.1555 20.8642 21.3526 20.7815 21.5586 20.7798C21.7646 20.778 21.9631 20.8572 22.1113 21.0003L22.6668 21.5558C22.8141 21.7031 22.8968 21.9029 22.8968 22.1113C22.8968 22.3196 22.8141 22.5194 22.6668 22.6668ZM22.6668 10.4442L22.1113 10.9997C21.9631 11.1428 21.7646 11.222 21.5586 11.2202C21.3526 11.2185 21.1555 11.1358 21.0099 10.9901C20.8642 10.8445 20.7815 10.6474 20.7798 10.4414C20.778 10.2354 20.8572 10.0369 21.0003 9.88871L21.5558 9.33321C21.704 9.19009 21.9024 9.11089 22.1085 9.11268C22.3145 9.11447 22.5115 9.19711 22.6572 9.34278C22.8029 9.48846 22.8855 9.68553 22.8873 9.89154C22.8891 10.0976 22.8099 10.296 22.6668 10.4442ZM24.6429 15.2143C24.8512 15.2143 25.0511 15.2971 25.1984 15.4444C25.3458 15.5918 25.4286 15.7916 25.4286 16C25.4286 16.2084 25.3458 16.4082 25.1984 16.5556C25.0511 16.7029 24.8512 16.7857 24.6429 16.7857H23.8571C23.6488 16.7857 23.4489 16.7029 23.3016 16.5556C23.1542 16.4082 23.0714 16.2084 23.0714 16C23.0714 15.7916 23.1542 15.5918 23.3016 15.4444C23.4489 15.2971 23.6488 15.2143 23.8571 15.2143H24.6429Z"
          fill="url(#paint1_linear_1323_14866)"
        />
        <defs>
          <radialGradient
            id="paint0_radial_1323_14866"
            cx="0"
            cy="0"
            r="1"
            gradientUnits="userSpaceOnUse"
            gradientTransform="translate(31 11.5) rotate(127.569) scale(24.6018)"
          >
            <stop stop-color="#FFD744" />
            <stop offset="1" stop-color="#EDBA00" />
          </radialGradient>
          <linearGradient
            id="paint1_linear_1323_14866"
            x1="5"
            y1="5"
            x2="27.6536"
            y2="5.3875"
            gradientUnits="userSpaceOnUse"
          >
            <stop stop-color="#FFD744" />
            <stop offset="1" stop-color="#EDBA00" />
          </linearGradient>
        </defs>
      </svg>
    ),
    backgroundColor: "linear-gradient(to right, #FFD744 , #EDBA00)",
    color: "rgba(237, 186, 0, 1)",
  },
  done: {
    name: "",
    icon: (
      <svg
        width="32"
        height="32"
        viewBox="0 0 32 32"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <circle
          cx="16"
          cy="16"
          r="15"
          stroke="url(#paint0_radial_1193_11495)"
          stroke-width="2"
        />
        <path
          d="M14.9854 5.04375C12.905 5.23674 10.9226 6.01813 9.27005 7.29653C7.61748 8.57493 6.36311 10.2975 5.65367 12.2626C4.94422 14.2278 4.80903 16.3544 5.26391 18.3936C5.71879 20.4328 6.74494 22.3003 8.22231 23.7777C9.69968 25.2551 11.5672 26.2812 13.6064 26.7361C15.6456 27.191 17.7722 27.0558 19.7374 26.3463C21.7025 25.6369 23.4251 24.3825 24.7035 22.73C25.9819 21.0774 26.7633 19.095 26.9563 17.0146C27.0999 15.4065 26.8888 13.7865 26.338 12.2689C25.7872 10.7513 24.9101 9.37311 23.7685 8.23151C22.6269 7.08992 21.2487 6.21277 19.7311 5.66196C18.2135 5.11116 16.5935 4.90012 14.9854 5.04375ZM21.9086 13.5281L15.3888 19.9798C15.1932 20.1702 14.931 20.2767 14.658 20.2767C14.385 20.2767 14.1228 20.1702 13.9272 19.9798L10.0844 16.31C9.88367 16.1172 9.76771 15.8525 9.76206 15.5742C9.75641 15.2959 9.86154 15.0268 10.0543 14.826C10.2471 14.6253 10.5118 14.5093 10.79 14.5037C11.0683 14.498 11.3375 14.6031 11.5382 14.7959L14.6397 17.7716L20.4443 12.0376C20.6435 11.8504 20.908 11.7485 21.1814 11.7536C21.4547 11.7587 21.7152 11.8704 21.9073 12.0649C22.0994 12.2594 22.2079 12.5213 22.2096 12.7946C22.2113 13.068 22.1061 13.3312 21.9165 13.5281H21.9086Z"
          fill="url(#paint1_linear_1193_11495)"
        />
        <defs>
          <radialGradient
            id="paint0_radial_1193_11495"
            cx="0"
            cy="0"
            r="1"
            gradientUnits="userSpaceOnUse"
            gradientTransform="translate(31 11.5) rotate(127.569) scale(24.6018)"
          >
            <stop stop-color="#7EFE1B" />
            <stop offset="1" stop-color="#4FB600" />
          </radialGradient>
          <linearGradient
            id="paint1_linear_1193_11495"
            x1="-0.72"
            y1="-3.8"
            x2="32.3982"
            y2="1.86297"
            gradientUnits="userSpaceOnUse"
          >
            <stop stop-color="#7EFE1B" />
            <stop offset="1" stop-color="#4FB600" />
          </linearGradient>
        </defs>
      </svg>
    ),
    backgroundColor: "linear-gradient(to right, #7EFE1B , #4FB600)",
    color: "rgb(82,187,2)",
  },
  missed: {
    name: "",
    icon: (
      <svg
        width="32"
        height="32"
        viewBox="0 0 32 32"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <circle
          cx="16"
          cy="16"
          r="15"
          stroke="url(#paint0_radial_1193_11475)"
          stroke-width="2"
        />
        <path
          d="M23.7733 23.7733C25.9244 21.6222 27 19.0311 27 16C27 12.9526 25.9244 10.3574 23.7733 8.21444C21.6222 6.07148 19.0311 5 16 5C12.9607 5 10.3656 6.07148 8.21444 8.21444C6.07148 10.3656 5 12.9607 5 16C5 19.0311 6.07148 21.6222 8.21444 23.7733C10.3656 25.9244 12.9607 27 16 27C19.0311 27 21.6222 25.9244 23.7733 23.7733ZM16 14.35L19.0067 11.3433C19.2267 11.1152 19.4996 11.0011 19.8256 11.0011C20.1433 11.0011 20.4204 11.1152 20.6567 11.3433C20.8767 11.5715 20.9867 11.8444 20.9867 12.1622C20.9867 12.4881 20.8767 12.7652 20.6567 12.9933L17.65 16L20.6567 19.0067C20.8848 19.2348 20.9989 19.5078 20.9989 19.8256C20.9989 20.1515 20.8848 20.4285 20.6567 20.6567C20.4285 20.8848 20.1515 20.9989 19.8256 20.9989C19.5078 20.9989 19.2348 20.8848 19.0067 20.6567L16 17.65L12.9933 20.6567C12.7652 20.8848 12.4881 20.9989 12.1622 20.9989C11.8444 20.9989 11.5715 20.8848 11.3433 20.6567C11.1152 20.4285 11.0011 20.1515 11.0011 19.8256C11.0011 19.5078 11.1152 19.2348 11.3433 19.0067L14.35 16L11.3433 13.0056C11.1152 12.7693 11.0011 12.4922 11.0011 12.1744C11.0011 11.8567 11.1152 11.5837 11.3433 11.3556C11.5715 11.1193 11.8444 11.0011 12.1622 11.0011C12.4881 11.0011 12.7652 11.1193 12.9933 11.3556L16 14.35Z"
          fill="url(#paint1_linear_1193_11475)"
          fill-opacity="0.9"
        />
        <defs>
          <radialGradient
            id="paint0_radial_1193_11475"
            cx="0"
            cy="0"
            r="1"
            gradientUnits="userSpaceOnUse"
            gradientTransform="translate(31 11.5) rotate(127.569) scale(24.6018)"
          >
            <stop stop-color="#FF2727" />
            <stop offset="1" stop-color="#991717" />
          </radialGradient>
          <linearGradient
            id="paint1_linear_1193_11475"
            x1="16"
            y1="5"
            x2="16"
            y2="27"
            gradientUnits="userSpaceOnUse"
          >
            <stop stop-color="#FF2727" />
            <stop offset="1" stop-color="#991717" />
          </linearGradient>
        </defs>
      </svg>
    ),
    backgroundColor: "linear-gradient(to right, #FF2727 , #B70202)",
    color: "rgba(183, 2, 2, 1)",
  },
  locked: {
    name: "",
    icon: (
      <svg
        width="30"
        height="32"
        viewBox="0 0 32 32"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <circle
          cx="16"
          cy="16"
          r="15"
          stroke="url(#paint0_linear_1193_11523)"
          stroke-width="2"
        />
        <path
          d="M5 16C5 9.92584 9.92584 5 16 5C22.0742 5 27 9.92584 27 16C27 22.0742 22.0742 27 16 27C9.92584 27 5 22.0742 5 16Z"
          fill="url(#paint1_linear_1193_11523)"
          fill-opacity="0.7"
        />
        <path
          d="M10.5781 15.2998H21.4229V22.3849H10.5781V15.2998Z"
          fill="white"
        />
        <path
          d="M20.1542 19.7284C19.8128 19.7284 19.5334 19.449 19.5334 19.1077V13.0778C19.5334 11.127 17.9462 9.53974 15.9953 9.53974C14.0445 9.53974 12.4573 11.127 12.4573 13.0778V19.1077C12.4573 19.449 12.1779 19.7284 11.8365 19.7284C11.4951 19.7284 11.2158 19.449 11.2158 19.1077V13.0778C11.2158 10.4442 13.3573 8.30273 15.9909 8.30273C18.6245 8.30273 20.766 10.4442 20.766 13.0778V19.1077C20.7749 19.4535 20.4955 19.7284 20.1542 19.7284Z"
          fill="white"
        />
        <path
          d="M17.179 18.363C17.179 17.7112 16.6514 17.1836 15.9997 17.1836C15.3479 17.1836 14.8203 17.7112 14.8203 18.363C14.8203 18.7797 15.0331 19.1433 15.3568 19.3517C15.3568 19.5379 15.3568 19.7684 15.3568 19.8615C15.3568 20.2162 15.645 20.5044 15.9997 20.5044C16.3544 20.5044 16.6426 20.2162 16.6426 19.8615C16.6426 19.7729 16.6426 19.5423 16.6426 19.3517C16.9662 19.1433 17.179 18.7753 17.179 18.363Z"
          fill="url(#paint2_linear_1193_11523)"
          fill-opacity="0.7"
        />
        <defs>
          <linearGradient
            id="paint0_linear_1193_11523"
            x1="31"
            y1="7"
            x2="2.5"
            y2="26"
            gradientUnits="userSpaceOnUse"
          >
            <stop stop-color="#C0C0C0" />
            <stop offset="1" stop-color="#7F7F7F" />
          </linearGradient>
          <linearGradient
            id="paint1_linear_1193_11523"
            x1="25"
            y1="9"
            x2="7.5"
            y2="22.5"
            gradientUnits="userSpaceOnUse"
          >
            <stop stop-color="#C0C0C0" />
            <stop offset="0.935" stop-color="#7F7F7F" />
          </linearGradient>
          <linearGradient
            id="paint2_linear_1193_11523"
            x1="16.9646"
            y1="17.7874"
            x2="14.6628"
            y2="19.0486"
            gradientUnits="userSpaceOnUse"
          >
            <stop stop-color="#C0C0C0" />
            <stop offset="0.935" stop-color="#7F7F7F" />
          </linearGradient>
        </defs>
      </svg>
    ),
    backgroundColor: "linear-gradient(to right, #C0C0C0 , #7F7F7F)",
    color: "rgba(24, 50, 78, 0.3)",
  },
  need_admin_approve: {
    name: "",
    icon: (
      <svg
        width="32"
        height="32"
        viewBox="0 0 32 32"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <circle
          cx="16"
          cy="16"
          r="15"
          stroke="url(#paint0_radial_1193_11503)"
          stroke-width="2"
        />
        <path
          d="M16 5C9.93263 5 5 9.93263 5 16C5 22.0674 9.93263 27 16 27C22.0674 27 27 22.0674 27 16C27 9.93263 22.0674 5 16 5ZM16 10.9284C17.8989 10.9284 19.4505 12.48 19.4505 14.3789C19.4505 16.2779 17.8989 17.8295 16 17.8295C14.1011 17.8295 12.5495 16.2779 12.5495 14.3789C12.5495 12.48 14.1011 10.9284 16 10.9284ZM10.984 23.4565C10.4335 23.0832 10.1581 22.3985 10.4023 21.7799C11.0202 20.2145 12.5494 19.1032 14.3326 19.1032H17.6674C19.4506 19.1032 20.9798 20.2145 21.5977 21.7799C21.8419 22.3985 21.5665 23.0832 21.016 23.4565C19.5845 24.4271 17.864 24.9853 16 24.9853C14.136 24.9853 12.4155 24.4271 10.984 23.4565Z"
          fill="url(#paint1_linear_1193_11503)"
        />
        <defs>
          <radialGradient
            id="paint0_radial_1193_11503"
            cx="0"
            cy="0"
            r="1"
            gradientUnits="userSpaceOnUse"
            gradientTransform="translate(31 11.5) rotate(127.569) scale(24.6018)"
          >
            <stop stop-color="#FF9B26" />
            <stop offset="1" stop-color="#ED8000" />
          </radialGradient>
          <linearGradient
            id="paint1_linear_1193_11503"
            x1="5"
            y1="5"
            x2="27.6536"
            y2="5.3875"
            gradientUnits="userSpaceOnUse"
          >
            <stop stop-color="#FF9B26" />
            <stop offset="1" stop-color="#ED8000" />
          </linearGradient>
        </defs>
      </svg>
    ),
    backgroundColor: "linear-gradient(to right, #FF9B26 , #ED8000)",
    color: "rgba(237, 128, 0, 1)",
  },
  need_sign_by_user: {
    name: "",
    icon: (
      <svg
        width="32"
        height="32"
        viewBox="0 0 32 32"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <circle
          cx="16"
          cy="16"
          r="15"
          stroke="url(#paint0_radial_1325_19358)"
          stroke-width="2"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M5 16C5 9.92584 9.92584 5 16 5C22.0742 5 27 9.92584 27 16C27 22.0742 22.0742 27 16 27C9.92584 27 5 22.0742 5 16ZM19.7355 14.0443L17.956 12.2649L17.6817 11.9905L17.4074 11.7162C15.5864 13.5372 12.9963 13.9307 12.9699 13.9345L12.7542 13.966L9 22.7261L14.2997 17.4268C14.2314 17.3111 14.1895 17.1784 14.1895 17.0349C14.1895 16.6069 14.5375 16.2588 14.9655 16.2588C15.3935 16.2588 15.7416 16.6069 15.7416 17.0349C15.7416 17.4629 15.3935 17.8109 14.9655 17.8109C14.822 17.8109 14.6892 17.769 14.574 17.7011L9.27472 23L18.0344 19.2455L18.0659 19.0301C18.0693 19.0041 18.4632 16.4136 20.2842 14.5926L20.0099 14.3187L19.7355 14.0443ZM22.4517 12.8803L22.726 13.1546L23.0003 13.4289L22.1106 14.3187C21.9593 14.47 21.7606 14.5457 21.5619 14.5457C21.3632 14.5457 21.1646 14.47 21.0132 14.3187L17.6817 10.9871C17.379 10.6844 17.379 10.1924 17.6817 9.88974L18.5714 9L18.8457 9.27433L19.1201 9.54867L22.4517 12.8803Z"
          fill="url(#paint1_linear_1325_19358)"
        />
        <defs>
          <radialGradient
            id="paint0_radial_1325_19358"
            cx="0"
            cy="0"
            r="1"
            gradientUnits="userSpaceOnUse"
            gradientTransform="translate(31 11.5) rotate(127.569) scale(24.6018)"
          >
            <stop stop-color="#00FFF0" />
            <stop offset="1" stop-color="#00C8BD" />
          </radialGradient>
          <linearGradient
            id="paint1_linear_1325_19358"
            x1="-2.47712"
            y1="-13.15"
            x2="34.2061"
            y2="-6.45465"
            gradientUnits="userSpaceOnUse"
          >
            <stop stop-color="#00FFF0" />
            <stop offset="1" stop-color="#00C8BD" />
          </linearGradient>
        </defs>
      </svg>
    ),
    backgroundColor:
      "linear-gradient(100.34deg, #00F2E4 -41.47%, #00C8BD 104.23%, #12C4BA 104.24%)",
    color: "rgba(18, 196, 186, 1)",
  },
  no_show: {
    name: "",
    icon: (
      <svg
        width="32"
        height="32"
        viewBox="0 0 32 32"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <circle
          cx="16"
          cy="16"
          r="15"
          stroke="url(#paint0_radial_1193_11475)"
          stroke-width="2"
        />
        <path
          d="M23.7733 23.7733C25.9244 21.6222 27 19.0311 27 16C27 12.9526 25.9244 10.3574 23.7733 8.21444C21.6222 6.07148 19.0311 5 16 5C12.9607 5 10.3656 6.07148 8.21444 8.21444C6.07148 10.3656 5 12.9607 5 16C5 19.0311 6.07148 21.6222 8.21444 23.7733C10.3656 25.9244 12.9607 27 16 27C19.0311 27 21.6222 25.9244 23.7733 23.7733ZM16 14.35L19.0067 11.3433C19.2267 11.1152 19.4996 11.0011 19.8256 11.0011C20.1433 11.0011 20.4204 11.1152 20.6567 11.3433C20.8767 11.5715 20.9867 11.8444 20.9867 12.1622C20.9867 12.4881 20.8767 12.7652 20.6567 12.9933L17.65 16L20.6567 19.0067C20.8848 19.2348 20.9989 19.5078 20.9989 19.8256C20.9989 20.1515 20.8848 20.4285 20.6567 20.6567C20.4285 20.8848 20.1515 20.9989 19.8256 20.9989C19.5078 20.9989 19.2348 20.8848 19.0067 20.6567L16 17.65L12.9933 20.6567C12.7652 20.8848 12.4881 20.9989 12.1622 20.9989C11.8444 20.9989 11.5715 20.8848 11.3433 20.6567C11.1152 20.4285 11.0011 20.1515 11.0011 19.8256C11.0011 19.5078 11.1152 19.2348 11.3433 19.0067L14.35 16L11.3433 13.0056C11.1152 12.7693 11.0011 12.4922 11.0011 12.1744C11.0011 11.8567 11.1152 11.5837 11.3433 11.3556C11.5715 11.1193 11.8444 11.0011 12.1622 11.0011C12.4881 11.0011 12.7652 11.1193 12.9933 11.3556L16 14.35Z"
          fill="url(#paint1_linear_1193_11475)"
          fill-opacity="0.9"
        />
        <defs>
          <radialGradient
            id="paint0_radial_1193_11475"
            cx="0"
            cy="0"
            r="1"
            gradientUnits="userSpaceOnUse"
            gradientTransform="translate(31 11.5) rotate(127.569) scale(24.6018)"
          >
            <stop stop-color="#FF2727" />
            <stop offset="1" stop-color="#991717" />
          </radialGradient>
          <linearGradient
            id="paint1_linear_1193_11475"
            x1="16"
            y1="5"
            x2="16"
            y2="27"
            gradientUnits="userSpaceOnUse"
          >
            <stop stop-color="#FF2727" />
            <stop offset="1" stop-color="#991717" />
          </linearGradient>
        </defs>
      </svg>
    ),
    backgroundColor: "linear-gradient(to right, #FF2727 , #B70202)",
    color: "rgba(183, 2, 2, 1)",
  },
};
const Step = ({
  step,
  isFirst,
  isLast,
  isPurchase,
  patientId,
  name,
  email,
  serviceId,
  fetchService,
  isEdit,
  needUpdate,
  setNeedUpdate,
  serviceName,
  userId,
  setSelect,
  setIsOpen2,
  getService,
  tempStep = null,
  setIsPayment,
  users,
  getUsers,
  patient,
  openPayModal,
  desible,
}) => {
  const bottomRef = useRef(null);
  const [isOpen, setIsOpen] = useState(
    step.type == "information" && isPurchase && !step.hide ? true : false
  );
  const { getUserConfig } = useConfig();
  const quillRef = useRef(null);
  const [isOpenTemplate, setIsOpenTemplate] = useState(false);
  const [TemplateData, setTemplateData] = useState([]);
  const [selectedTemplate, setSelectedTemplate] = useState();
  const [isReed, setIsReed] = useState(true);
  const [isOpenStatus, setIsOpenStatus] = useState(false);
  const [openReply, setOpenReply] = useState(false);
  const [openReject, setOpenReject] = useState(false);
  const [openPreview, setOpenPreview] = useState(false);
  const [openEditReply, setEditReply] = useState(false);
  const [isOpenAppointment, setIsOpenAppointment] = useState(false);
  const [openTranslator, setOpenTranslator] = useState(false);
  const [lang, setLang] = useState("");
  const [langs, setLangs] = useState([]);
  const [showInterpreterButton, setShowInterpreterButton] = useState(false);
  const [interpreterLink, setInterpreterLink] = useState("");
  const [interpreterText, setInterpreterText] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [item, setItem] = useState({});
  const [reply, setReply] = useState([]);
  const [showReply, setShowReply] = useState(false);
  const [current, setCurrent] = useState({});
  const [locations, setLocations] = useState([]);
  const [location, setLocation] = useState("online");
  const [changeLocation, setChangeLocation] = useState(false);
  const [copyLink, setCopyLink] = useState(false);
  const [replyText, setReplyText] = useState("");
  const [isOpenEditUrl, setIsOpenEditUrl] = useState(false);
  const [isopenmessage, setisopenmessage] = useState(false);
  const [isopencomment, setisopencomment] = useState(false);
  const [isopenupload, setisopenupload] = useState(false);
  const [isopennewupload, setisopennewupload] = useState(false);
  const isMobile = useMobile();
  const [data, setdata] = useState([]);
  const [categoris, setCategoris] = useState([]);
  const [isopenchangestatus, setisopenchangestatus] = useState(false);
  const [isopeneditupload, setisopeneditupload] = useState(false);
  const [comments, setComments] = useState([]);
  const [isopennewcomment, setisopennewcomment] = useState(false);
  const [defult, setDefult] = useState({});
  const [activeStatuse, setActiveStatuse] = useState([]);
  const [form] = Form.useForm();
  const currentpath = useLocation();

  const modules = {
    toolbar: {
      container: [
        [{ header: "1" }, { header: "2" }, { font: [] }],
        [{ size: [] }],
        ["bold", "italic", "underline", "strike", "blockquote"],
        [
          { list: "ordered" },
          { list: "bullet" },
          { indent: "-1" },
          { indent: "+1" },
        ],
        ["link"],
        ["clean"],
      ],
    },
  };
  const formats = [
    "header",
    "font",
    "size",
    "bold",
    "italic",
    "underline",
    "strike",
    "blockquote",
    "list",
    "bullet",
    "indent",
    "link",
  ];

  const handleChange = useCallback((html) => {
    setReplyText(html);

    setCurrent({
      ...current,
      message: html,
      subject: null,
    });
  }, []);

  const [document, setDocument] = useState({
    category: {},
    categoryId: "",
  });
  const [newDoc, setNewDoc] = useState({
    title: "",
    description: "",
    file: "",
    category: {},
  });

  const { confirm } = Modal;

  const columnsTemplate = [
    {
      title: "Title",
      dataIndex: "category",
      key: "category",
      //   width: "15%",
      // ...getColumnSearchProps("category"),
    },
    {
      title: "Subject",
      dataIndex: "subject",
      key: "subject",
      // ...getColumnSearchProps("subject"),
    },
    {
      title: "Created at",
      dataIndex: "createdAt",
      key: "createdAt",
      render: (record) => new Date(record).toDateString(),
      // ...getColumnSearchProps("createdAt"),
    },
  ];

  const fetchLangs = async () => {
    setIsLoading(true);
    getUserConfig();
    var res = JSON.parse(localStorage.getItem("config"));

    if (res.status == 200) {
      var filtered = res.data.data.appointment.translator.languages.filter(
        function (el) {
          return el != null;
        }
      );
      // console.log(filtered);
      setLangs(filtered);
    }
    setIsLoading(false);
  };
  const getForm = async () => {
    setIsLoading(true);
    var res = await fetchData(`admin/form/` + step.modelId);

    if (res.status == 200) {
      setIsLoading(false);
      var form = res.data.data;
      var link = window.document.createElement("a");
      link.href =
        "https://form.jotform.com/" +
        form.code +
        "?email=" +
        JSON.stringify({
          patientId: patientId,
          redirectUrl: `https://cpanel.iqliniq.com/patients/${patientId}/services/in-progress/${serviceId}`,
        });

      link.click();
      setIsLoading(false);
    } else {
      Modal.error({
        title: "Form not found!",
      });
    }
    setIsLoading(false);
  };
  const getComments = async () => {
    setIsLoading(true);
    var res = await fetchData(
      `admin/comment?parentId=0&deletedAt=false&includes[]=watchers&purchaseStepId=${step.id}&includes[]=reporter&includes[]=assignees&includes[]=attachments&includes[]=replies`
    );
    if (res.status == 200) {
      setComments(res.data.data);
      if (users.length == 0) {
        await getUsers();
      }
    }
    setIsLoading(false);
  };
  const removeDocument = async (id) => {
    setIsLoading(true);
    var res = await deleteData("admin/document/" + id);
    if (res.status === 200) {
      fetchDocuments();
    } else {
      Modal.error({ title: res });
    }
    setIsLoading(false);
  };

  const Reed = async (reply) => {
    if (reply.senderId !== userId) {
      var res = await putData(
        `admin/service-purchase/${serviceId}/step/${step.id}/reply/${reply.id}/read`,
        {}
      );
    }
  };

  const getLocation = async () => {
    setIsLoading(true);
    var res = await fetchData("admin/appointment-event/" + step.modelId);
    if (res.status == 200) {
      setLocations(res.data.data.locationTypes);
    }
    setIsLoading(false);
  };
  const showApproveConfirm = async () => {
    confirm({
      title: "Are you sure approve this step?",
      icon: <ExclamationCircleFilled />,
      okText: "Yes",
      okType: "danger",
      cancelText: "No",
      onOk() {
        approve();
      },
      onCancel() {},
    });
  };

  const fetchItem = async () => {
    setIsLoading(true);
    var res = await fetchData(`admin/appointment/${step.modelIdResult}`);
    if (res.status == 200) {
      setItem(res.data.data);
    }
    setIsLoading(false);
  };

  const hide = async () => {
    setIsLoading(true);
    var res = await putData(
      `admin/service-purchase/${serviceId}/step/${step.id}/hide`,
      { hide: true }
    );
    if (res.status != 200) {
      Modal.error({ title: res });
    }
    await getService();
    setIsLoading(false);
  };
  const unHide = async () => {
    setIsLoading(true);
    var res = await putData(
      `admin/service-purchase/${serviceId}/step/${step.id}/hide`,
      { hide: false }
    );
    if (res.status != 200) {
      Modal.error({ title: res });
    }
    await getService();
    setIsLoading(false);
  };
  const sendSignform = async () => {
    setIsLoading(true);
    var res = await putData(
      `admin/service-purchase/${serviceId}/step/${step.id}/sign`
    );
    if (res.status != 200) {
      Modal.error({ title: res });
    }
    await getService();
    setIsLoading(false);
  };

  const approveByUser = async () => {
    setIsLoading(true);
    var res = await putData(
      `admin/service-purchase/${serviceId}/step/${step.id}/approveByUser`
    );
    if (res.status != 200) {
      Modal.error({ title: res });
    }
    await getService();
    setIsLoading(false);
  };
  const approve = async () => {
    setIsLoading(true);
    var res = await putData(
      `admin/service-purchase/${serviceId}/step/${step.id}/approve`
    );
    if (res.status == 200) {
      Modal.success({ title: res.data.message });
      await fetchService();
    } else {
      Modal.error({ title: res });
    }
    setIsLoading(false);
  };
  const reject = async (current) => {
    setIsLoading(true);
    var res = await putData(
      `admin/service-purchase/${serviceId}/step/${step.id}/decline`,
      current
    );
    if (res.status == 200) {
      Modal.success({ title: res.data.message });
      await fetchService();
    } else {
      Modal.error({ title: res });
    }
    setIsLoading(false);
  };
  const preview = async (id) => {
    setIsLoading(true);
    var res = await putData(`admin/sign-form-request/${id}/preview`, current);
    if (res.status == 200) {
      setCurrent(res.data.data);
    } else {
      Modal.error({ title: res });
    }
    setIsLoading(false);
  };
  const resend = async (id) => {
    setIsLoading(true);
    var res = await putData(`admin/sign-form-request/${id}/resend`);
    if (res.status == 200) {
      Modal.success({ title: res.data.message });
      await fetchService();
    } else {
      Modal.error({ title: res });
    }
    form.resetFields();
    setIsLoading(false);
  };
  const sendReply = async (r) => {
    setIsLoading(true);
    var res = await postData(
      `admin/service-purchase/${serviceId}/step/${step.id}/reply`,
      r
    );
    if (res.status == 201) {
      setOpenReply(false);
      // await fetchService();
      await fetchReply();
    } else {
      Modal.error({ title: res });
    }
    setIsLoading(false);
  };

  const editReply = async (r) => {
    setIsLoading(true);
    var res = await putData(
      `admin/service-purchase/${serviceId}/step/${step.id}/reply/${r.id}`,
      r
    );
    if (res.status == 200) {
      setOpenReply(false);
      await fetchReply();
      // await fetchService();
    } else {
      Modal.error({ title: res });
    }
    setIsLoading(false);
  };

  const fetchReply = async () => {
    setIsLoading(true);
    var res = await fetchData(
      `admin/service-purchase/${serviceId}/step/${step.id}/reply`
    );
    if (res.status == 200) {
      setReply(res.data.data);
    }
    setIsLoading(false);
  };
  const deleteReply = async (r) => {
    setIsLoading(true);
    var res = await deleteData(
      `admin/service-purchase/${serviceId}/step/${step.id}/reply/${r.id}`
    );
    if (res.status == 200) {
      setReply(
        reply.filter((f) => {
          return f.id != r.id;
        })
      );
    } else {
      Modal.error({ title: res });
    }
    setIsLoading(false);
  };

  async function fetchDocuments() {
    setIsLoading(true);
    var domain = step.id
      ? "admin/document/?patientId=" + patientId + "&purchaseStepId=" + step.id
      : "admin/document/?patientId=" + patientId;
    var res = await fetchData(domain);
    if (res.status === 200) {
      setdata(res.data.data);
    }
    // console.log(res.data.data);
    var res2 = await fetchData("admin/document-category");
    // console.log(res2.data.data);
    if (res2.status === 200) {
      setCategoris(
        res2.data.data.filter((s) => {
          return !s.deletedAt;
        })
      );
    } else {
      Modal.error({
        title: res2,
      });
    }
    setIsLoading(false);
  }

  const addDocument = async () => {
    setIsLoading(true);
    let formData = new FormData();
    formData.append("title", newDoc.file.name);
    formData.append("description", newDoc.description ?? "");
    formData.append("file", newDoc.file);
    formData.append("categoryId", newDoc.categoryId);
    formData.append("patientId", patientId);
    if (step.id) {
      formData.append("purchaseStepId", step.id);
    }
    var res = await postFormData("admin/document", formData);
    if (res.status === 201) {
      setIsOpen(false);
      setNewDoc({
        title: "",
        description: "",
        file: "",
        category: {},
      });
      fetchDocuments();
    } else {
      Modal.error({
        title: res,
      });
    }
    setisopennewupload(false);
    setIsLoading(false);
  };

  const editDocument = async () => {
    setIsLoading(true);
    let formData = new FormData();
    formData.append("title", document.title);
    formData.append("description", document.description);
    formData.append("categoryId", document.categoryId);
    if (document.file) formData.append("file", document.file);
    var res = await putFormData("admin/document/" + document.id, formData);
    if (res.status === 200) {
      fetchDocuments();
      setDocument({
        title: "",
        description: "",
        file: "",
        category: {},
      });
      setisopeneditupload(false);
    } else {
      Modal.error({
        title: res,
      });
    }
    setIsLoading(false);
  };

  const fetchEmailsTemplates = async (page = 1, reload = false) => {
    setIsLoading(true);
    var temp = TemplateData;
    if (reload) {
      temp = [];
    }
    if (TemplateData.length < (page - 1) * 15 + 2 || reload) {
      var res = await fetchData(`admin/template?perPage=15&page=` + page);
      if (res.status === 200) {
        if (res.data.data.length < 15) {
          setTemplateData(
            temp
              .filter((a, i) => {
                return a.category;
              })
              .concat(res.data.data)
          );
        } else {
          setTemplateData(
            temp
              .filter((a, i) => {
                return a.category;
              })
              .concat([...res.data.data])
          );
        }
      }
    }

    setIsLoading(false);
  };

  async function fetchEmailsTemplate(id) {
    setIsLoading(true);

    var res = await fetchData(`admin/template/${id}`);
    if (res.status == 200) {
      setReplyText(res.data.data.message);
      // setEmailInfo(res.data.data);
      // setMessage(res.data.data.message);
    }
    setIsLoading(false);
  }

  useEffect(() => {
    fetchEmailsTemplates();

    fetchLangs();
    if (tempStep) {
      bottomRef.current.scrollIntoView({ behavior: "smooth" });
      setIsOpen(false);
      setisopenmessage(true);
    }
    if (isPurchase) {
      fetchReply();
      getUserConfig();
      var config = JSON.parse(localStorage.getItem("config"));
      config.data.data.service.activeStepStatuses &&
        setActiveStatuse(
          config.data.data.service.activeStepStatuses[step.type]
        );
    }
    if (isPurchase && step.modelId && step.type == "appointment") {
      if (
        step.modelIdResult !== null &&
        privilage.indexOf(
          access.patientManegment.service.step.showApoointment
        ) > -1
      ) {
        fetchItem();
      } else {
        setIsLoading(false);
      }
    } else {
      setIsLoading(false);
    }
  }, []);

  const handleShowModal = (u) => {
    setDocument(u);
    setisopeneditupload(true); // This will trigger the useEffect above
  };
  if (step.visible) {
    return (
      <>
        <div
          ref={bottomRef}
          id={step.id}
          style={
            isMobile
              ? isPurchase
                ? { height: "150px", marginLeft: "-15px" }
                : { height: "95px" }
              : { height: "129px" }
          }
          className="d-flex flex-row "
        >
          {/* <div>kjsfkjdsfkj</div> */}
          <div
            style={{ alignItems: "center", justifyContent: "center" }}
            className="d-flex flex-column col-1"
          >
            {!isFirst ? (
              <di className="v-line" />
            ) : (
              <div style={{ height: "58px" }} />
            )}

            <div style={{ position: "relative" }}>
              {!isMobile && (
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    position: "absolute",
                    left: "-5px",
                    transform: "translate(-100%,0)",
                  }}
                >
                  <p
                    style={{
                      fontWeight: "400",
                      cursor: "pointer",
                      textDecoration: "underline",
                      textAlign: "center",
                      color: "#18324E",
                    }}
                    onClick={() => {
                      if (!desible) {
                        step.hide ? unHide() : hide();
                      }
                    }}
                  >
                    {step.hide ? (
                      <svg
                        width="20"
                        height="20"
                        viewBox="0 0 20 20"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M18.2431 10.1281C17.4521 9.09602 14.6841 6 10.1796 6C5.67499 6 2.9241 9.09608 2.11603 10.1281C1.96132 10.3173 1.96132 10.5925 2.11603 10.7818C2.90697 11.8138 5.67499 14.9099 10.1796 14.9099C14.6841 14.9099 17.435 11.8138 18.2431 10.7818C18.3806 10.5925 18.3806 10.3173 18.2431 10.1281ZM10.1796 13.7746C8.33984 13.7746 6.86131 12.2954 6.86131 10.4549C6.86131 8.61441 8.3399 7.13523 10.1796 7.13523C12.0193 7.13523 13.4978 8.61447 13.4978 10.4549C13.4978 12.2954 12.0193 13.7746 10.1796 13.7746Z"
                          fill="#4C4C4C"
                        />
                        <path
                          d="M12.6253 10.4587C12.6253 11.8137 11.5274 12.9121 10.173 12.9121C8.81865 12.9121 7.7207 11.8137 7.7207 10.4587C7.7207 9.10379 8.81865 8.00537 10.173 8.00537C11.5274 8.00537 12.6253 9.10379 12.6253 10.4587Z"
                          fill="#4C4C4C"
                        />
                      </svg>
                    ) : (
                      <svg
                        width="18"
                        height="16"
                        viewBox="0 0 18 16"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M17.4626 8.05142C16.9752 7.40675 15.748 6.02786 13.8528 4.9892L12.0841 6.74409C12.3548 7.22762 12.4992 7.80059 12.4992 8.39156C12.4992 10.3077 10.947 11.8477 9.01578 11.8477C8.42018 11.8477 7.84269 11.7044 7.35531 11.4358L6.16406 12.6178C7.03037 12.8685 7.96893 13.0296 9.01575 13.0296C13.7445 13.0296 16.6323 9.80628 17.4806 8.73184C17.6069 8.53485 17.6069 8.24843 17.4625 8.05145L17.4626 8.05142Z"
                          fill="#4C4C4C"
                        />
                        <path
                          d="M9.00115 10.8987C10.3909 10.8987 11.5279 9.77047 11.5279 8.39169C11.5279 8.06943 11.4558 7.74703 11.3474 7.46048L8.0625 10.7196C8.35143 10.827 8.67638 10.8986 9.00119 10.8986L9.00115 10.8987Z"
                          fill="#4C4C4C"
                        />
                        <path
                          d="M15.6563 1.03177C15.4216 0.798939 15.0427 0.798939 14.808 1.03177L11.7037 4.11184C10.8915 3.87901 9.98906 3.73572 9.01437 3.73572C4.28562 3.73572 1.39783 6.95905 0.549541 8.03349C0.387132 8.23048 0.387132 8.51702 0.549541 8.714C1.03689 9.34082 2.21002 10.6839 4.03294 11.7045L1.5963 14.1221C1.36163 14.3549 1.36163 14.7309 1.5963 14.9637C1.7227 15.0891 1.86698 15.1429 2.0295 15.1429C2.19191 15.1429 2.33631 15.0891 2.4627 14.9637L15.6743 1.85554C15.891 1.65856 15.891 1.2646 15.6563 1.03187L15.6563 1.03177ZM5.51296 8.3917C5.51296 6.47555 7.08316 4.93558 8.99635 4.93558C9.53785 4.93558 10.0612 5.06099 10.5306 5.29369L9.79053 6.02793C9.53785 5.95635 9.28516 5.90252 8.99635 5.90252C7.60657 5.90252 6.4696 7.03071 6.4696 8.40948C6.4696 8.67804 6.52374 8.94674 6.59601 9.19744L5.85598 9.93167C5.63931 9.44814 5.51302 8.92877 5.51302 8.39164L5.51296 8.3917Z"
                          fill="#4C4C4C"
                        />
                      </svg>
                    )}
                    {step.hide ? "Show" : "Hide"}
                  </p>
                </div>
              )}
              {isPurchase ? (
                statusList[step.status].icon
              ) : (
                <svg
                  width="32"
                  height="32"
                  viewBox="0 0 32 32"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <circle
                    cx="16"
                    cy="16"
                    r="15"
                    stroke="url(#paint0_linear_1320_12438)"
                    stroke-width="2"
                  />
                  <path
                    d="M5 16C5 9.92584 9.92584 5 16 5C22.0742 5 27 9.92584 27 16C27 22.0742 22.0742 27 16 27C9.92584 27 5 22.0742 5 16Z"
                    fill="url(#paint1_linear_1320_12438)"
                    fill-opacity="0.7"
                  />
                  <path
                    d="M10.5781 15.2998H21.4229V22.3849H10.5781V15.2998Z"
                    fill="white"
                  />
                  <path
                    d="M20.1542 19.7284C19.8128 19.7284 19.5334 19.449 19.5334 19.1077V13.0778C19.5334 11.127 17.9462 9.53974 15.9953 9.53974C14.0445 9.53974 12.4573 11.127 12.4573 13.0778V19.1077C12.4573 19.449 12.1779 19.7284 11.8365 19.7284C11.4951 19.7284 11.2158 19.449 11.2158 19.1077V13.0778C11.2158 10.4442 13.3573 8.30273 15.9909 8.30273C18.6245 8.30273 20.766 10.4442 20.766 13.0778V19.1077C20.7749 19.4535 20.4955 19.7284 20.1542 19.7284Z"
                    fill="white"
                  />
                  <path
                    d="M17.179 18.363C17.179 17.7112 16.6514 17.1836 15.9997 17.1836C15.3479 17.1836 14.8203 17.7112 14.8203 18.363C14.8203 18.7797 15.0331 19.1433 15.3568 19.3517C15.3568 19.5379 15.3568 19.7684 15.3568 19.8615C15.3568 20.2162 15.645 20.5044 15.9997 20.5044C16.3544 20.5044 16.6426 20.2162 16.6426 19.8615C16.6426 19.7729 16.6426 19.5423 16.6426 19.3517C16.9662 19.1433 17.179 18.7753 17.179 18.363Z"
                    fill="url(#paint2_linear_1320_12438)"
                    fill-opacity="0.7"
                  />
                  <defs>
                    <linearGradient
                      id="paint0_linear_1320_12438"
                      x1="31"
                      y1="7"
                      x2="2.5"
                      y2="26"
                      gradientUnits="userSpaceOnUse"
                    >
                      <stop stop-color="#C0C0C0" />
                      <stop offset="1" stop-color="#7F7F7F" />
                    </linearGradient>
                    <linearGradient
                      id="paint1_linear_1320_12438"
                      x1="25"
                      y1="9"
                      x2="7.5"
                      y2="22.5"
                      gradientUnits="userSpaceOnUse"
                    >
                      <stop stop-color="#C0C0C0" />
                      <stop offset="0.935" stop-color="#7F7F7F" />
                    </linearGradient>
                    <linearGradient
                      id="paint2_linear_1320_12438"
                      x1="16.9646"
                      y1="17.7874"
                      x2="14.6628"
                      y2="19.0486"
                      gradientUnits="userSpaceOnUse"
                    >
                      <stop stop-color="#C0C0C0" />
                      <stop offset="0.935" stop-color="#7F7F7F" />
                    </linearGradient>
                  </defs>
                </svg>
              )}
            </div>
            {!isLast ? (
              <di className="v-line" />
            ) : (
              <div style={{ height: "58px" }} />
            )}
          </div>
          <div
            style={
              isPurchase
                ? step.status == "done"
                  ? {
                      backgroundImage:
                        "linear-gradient(to right, rgba(126, 254, 27, 0.15) , rgba(79, 182, 0, 0.15))",
                      justifyContent: "space-between",
                      position: "relative",
                      padding: "10px",
                      maxHeight: "120px",
                      opacity: step.hide ? "35%" : "100%",
                    }
                  : step.status == "active"
                  ? {
                      opacity: step.hide ? "35%" : "100%",
                      backgroundImage:
                        "linear-gradient(to right, rgba(0, 224, 238, 0.1) , rgba(2, 139, 198, 0.1))",
                      justifyContent: "space-between",
                      position: "relative",
                      padding: "10px",
                      maxHeight: "120px",
                    }
                  : step.status == "is_scheduled"
                  ? {
                      opacity: step.hide ? "35%" : "100%",
                      backgroundImage:
                        "linear-gradient(to right, rgba(255, 215, 68, 0.12) , rgba(237, 186, 0, 0.12))",
                      justifyContent: "space-between",
                      position: "relative",
                      padding: "10px",
                      maxHeight: "120px",
                    }
                  : step.status == "missed" || step.status == "no_show"
                  ? {
                      opacity: step.hide ? "35%" : "100%",
                      backgroundImage:
                        "linear-gradient(to right, rgba(255, 39, 39, 0.08) , rgba(183, 2, 2, 0.08))",
                      justifyContent: "space-between",
                      position: "relative",
                      padding: "10px",
                      maxHeight: "120px",
                    }
                  : step.status == "need_admin_approve" ||
                    step.status == "choose_payment_method"
                  ? {
                      opacity: step.hide ? "35%" : "100%",
                      backgroundImage:
                        "linear-gradient(to right, rgba(255, 155, 38, 0.12) , rgba(237, 128, 0, 0.12))",
                      justifyContent: "space-between",
                      position: "relative",
                      padding: "10px",
                      maxHeight: "120px",
                    }
                  : step.status == "need_sign_by_user"
                  ? {
                      opacity: step.hide ? "35%" : "100%",
                      backgroundImage:
                        "linear-gradient(100.34deg, rgba(0, 255, 240, 0.1) -41.47%, rgba(0, 200, 189, 0.1) 104.23%)",
                      justifyContent: "space-between",
                      position: "relative",
                      padding: "10px",
                      maxHeight: "120px",
                    }
                  : {
                      opacity: step.hide ? "35%" : "100%",
                      backgroundImage:
                        "linear-gradient(to right, rgba(192, 192, 192, 0.25) , rgba(127, 127, 127, 0.25))",
                      justifyContent: "space-between",
                      position: "relative",
                      padding: "10px",
                      maxHeight: "120px",
                    }
                : {
                    opacity: step.hide ? "35%" : "100%",
                    backgroundImage:
                      "linear-gradient(to right, rgba(192, 192, 192, 0.25), rgba(127, 127, 127, 0.25))",
                    justifyContent: "space-between",
                    position: "relative",
                    padding: "10px",
                    maxHeight: "120px",
                  }
            }
            className={
              isMobile
                ? "step-box d-flex flex-column col-11"
                : "step-box d-flex flex-row col-11 "
            }
          >
            <>
              <div className={isMobile ? `col-12` : "col-5"}>
                <h2
                  className={isMobile ? `title col-11` : "title col-12"}
                  style={
                    step.status == "locked"
                      ? { color: "rgba(24, 50, 78, 0.40)" }
                      : {}
                  }
                >
                  {/* {console.log(item)} */}
                  {isPurchase && (
                    <span
                      style={{
                        fontSize: "12px",
                        color: "black",

                        backgroundImage: step.status
                          ? statusList[step.status].backgroundColor
                          : "linear-gradient(to right, #C0C0C0 , #7F7F7F)",
                        padding: "1px 5px 0px 5px",
                        maxHeight: "auto",
                        borderRadius: "2px",
                        position: "absolute",
                        color: "white",
                        marginTop: "-30px",
                        display: "flex",
                        alignItems: "center",
                      }}
                      className="change_status"
                      onClick={() => {
                        if (!desible)
                          setisopenchangestatus(!isopenchangestatus);
                      }}
                    >
                      <Select
                        open={isopenchangestatus}
                        defaultValue={step.status ? step.status : "locked"}
                        disabled={!step.status || desible}
                        style={
                          isopenchangestatus
                            ? { width: 170, backgroundColor: "inherit" }
                            : { width: "auto", backgroundColor: "inherit" }
                        }
                        suffixIcon={
                          step.status ? (
                            <CaretDownOutlined style={{ color: "white" }} />
                          ) : (
                            <></>
                          )
                        }
                        dropdownStyle={{ fontSize: "10px" }}
                        size="small"
                        onChange={async (value) => {
                          setIsLoading(true);
                          if (
                            privilage.indexOf(
                              access.patientManegment.service.step.editStatus
                            ) > -1
                          ) {
                            var res = await putData(
                              `admin/service-purchase/${serviceId}/step/${step.id}`,
                              { status: value }
                            );
                            if (res.status == 200) {
                              Modal.success({
                                title: res.data.message,
                              });

                              await fetchService();
                            }
                          } else {
                            Modal.error({ title: "you don't have permission" });
                          }
                          setIsLoading(false);
                        }}
                      >
                        {activeStatuse.map((s) => {
                          return (
                            <Select.Option
                              value={s}
                              disabled={step.status == s}
                            >
                              {s[0].toUpperCase() +
                                s.substring(1).replaceAll("_", "-")}
                            </Select.Option>
                          );
                        })}
                      </Select>
                    </span>
                  )}
                  {step.title.length > 30 ? (
                    <span title={step.title}>
                      {step.title.substring(0, 28)}...
                    </span>
                  ) : (
                    <span>{step.title}</span>
                  )}
                </h2>

                <div className="d-flex flex-row col-12">
                  <div>
                    {step.approvedById && (
                      <div
                        style={{ marginBottom: "8px" }}
                        className="d-flex flex-row gap-2"
                      >
                        <h3
                          style={{
                            color: "rgba(158, 158, 158, 1)",
                            fontSize: "11px",
                            fontWeight: "400",
                            marginRight: "-80px",
                          }}
                        >
                          Approved By User{" "}
                          <a
                            style={{ color: "rgba(158, 158, 158, 1)" }}
                            href={"users/" + step.approvedById}
                          >
                            {step.approvedById}
                          </a>{" "}
                          At {new Date(step.approvedAt).toLocaleString()}
                        </h3>
                      </div>
                    )}
                    {step.type === "appointment" && (
                      <div
                        style={{ marginBottom: "8px" }}
                        className="d-flex flex-row gap-2"
                      >
                        <svg
                          width="18"
                          height="16"
                          viewBox="0 0 18 16"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M15.4254 1.33087H13.813V1.63953C13.8136 1.82265 13.8136 2.00614 13.8125 2.18926C13.8077 2.87236 13.3176 3.39405 12.672 3.40352L12.6548 3.40403C12.0027 3.40403 11.5094 2.88411 11.5071 2.19436C11.506 1.8939 11.506 1.60699 11.506 1.33047H9.2974V1.67496C9.29791 1.85412 9.29855 2.03839 9.29625 2.22302C9.28793 2.88512 8.80063 3.39276 8.16284 3.40337L8.14339 3.40389C7.50216 3.40389 6.99629 2.88331 6.9922 2.21918C6.98989 1.92217 6.98874 1.62555 6.98938 1.33032H4.78223V1.40544C4.78171 1.49118 4.78223 1.57627 4.78223 1.66201C4.78274 1.84282 4.78274 2.02312 4.78171 2.20342C4.7757 2.87564 4.28777 3.3916 3.64716 3.40336H3.62566C2.98303 3.40336 2.47856 2.87446 2.47627 2.19857C2.47512 1.8976 2.47512 1.60956 2.47512 1.33058H0.867099C0.391336 1.33058 0.000255932 1.72101 0.000255932 2.19743L0 13.8909C0 14.4501 0.408738 14.8273 0.967938 14.8273H9.12238C8.8827 14.4417 8.6947 14.0213 8.56599 13.5755H3.82081C3.82132 13.5784 3.82132 13.581 3.82132 13.5832L1.24038 13.5904L1.2409 10.1919C1.2409 10.1914 1.24141 10.1914 1.24141 10.1908L1.24154 4.76127C1.24154 4.7518 1.25037 4.74297 1.25984 4.74297H15.0282C15.0371 4.74297 15.046 4.7518 15.046 4.76127V7.43331C15.4924 7.58815 15.9094 7.80388 16.2883 8.0711L16.2884 2.19474C16.2887 1.71832 15.9015 1.33111 15.4253 1.33111L15.4254 1.33087Z"
                            fill="#5F5F5F"
                          />
                          <path
                            d="M4.1866 1.40513C4.1866 1.66938 4.18826 1.93403 4.18609 2.19827C4.18327 2.54967 3.95332 2.80277 3.6357 2.80854C3.31438 2.81455 3.07188 2.55427 3.07073 2.19623C3.06907 1.66734 3.06868 1.13847 3.07073 0.609703C3.07214 0.256886 3.30146 0.00545852 3.61997 8.5999e-05C3.9427 -0.00541658 4.18379 0.253715 4.18635 0.611767C4.18827 0.876272 4.18686 1.14089 4.1866 1.40516L4.1866 1.40513Z"
                            fill="#5F5F5F"
                          />
                          <path
                            d="M8.70236 1.42226C8.70211 1.6869 8.70492 1.95116 8.70147 2.21566C8.69712 2.55338 8.46358 2.80353 8.15288 2.80877C7.83501 2.81427 7.58932 2.56141 7.58677 2.2154C7.58306 1.67474 7.58306 1.13421 7.58677 0.593553C7.58933 0.247288 7.83438 -0.00443444 8.15288 0.000184613C8.46192 0.00479122 8.69521 0.256116 8.70147 0.593553C8.70403 0.734572 8.70236 0.875591 8.70236 1.01661C8.70262 1.15199 8.70262 1.28725 8.70236 1.42226Z"
                            fill="#5F5F5F"
                          />
                          <path
                            d="M13.2188 1.40911C13.2188 1.6676 13.2202 1.92648 13.2186 2.18511C13.216 2.54969 12.9887 2.8042 12.664 2.80908C12.3435 2.81394 12.1041 2.5534 12.103 2.19281C12.1013 1.66391 12.1009 1.13478 12.103 0.605918C12.1044 0.256442 12.3394 0.00229604 12.6562 0.000527038C12.9758 -0.00113651 13.2137 0.249294 13.2179 0.598515C13.2216 0.868651 13.2188 1.13891 13.2188 1.40918L13.2188 1.40911Z"
                            fill="#5F5F5F"
                          />
                          <path
                            d="M4.85494 12.4355H2.72431C2.46979 12.4355 2.26172 12.2274 2.26172 11.9729V10.5675C2.26172 10.3129 2.46979 10.1049 2.72431 10.1049H4.85494C5.10947 10.1049 5.31754 10.3129 5.31754 10.5675V11.9729C5.31792 12.2273 5.10959 12.4355 4.85494 12.4355Z"
                            fill="#5F5F5F"
                          />
                          <path
                            d="M4.85494 8.44018H2.72431C2.46979 8.44018 2.26172 8.23211 2.26172 7.97759V6.57215C2.26172 6.31763 2.46979 6.10956 2.72431 6.10956H4.85494C5.10947 6.10956 5.31754 6.31763 5.31754 6.57215V7.97759C5.31792 8.23211 5.10959 8.44018 4.85494 8.44018Z"
                            fill="#5F5F5F"
                          />
                          <path
                            d="M8.37031 12.1826C8.37031 12.2672 8.37261 12.3514 8.37696 12.4354H7.07822C6.8237 12.4354 6.61523 12.2274 6.61523 11.9725V10.567C6.61523 10.3125 6.82331 10.104 7.07822 10.104H8.81843C8.53025 10.7381 8.37031 11.4413 8.37031 12.1826Z"
                            fill="#5F5F5F"
                          />
                          <path
                            d="M9.20943 8.44018H7.0788C6.82428 8.44018 6.61621 8.23211 6.61621 7.97759V6.57215C6.61621 6.31763 6.82428 6.10956 7.0788 6.10956H9.20943C9.46396 6.10956 9.67203 6.31763 9.67203 6.57215V7.97759C9.67203 8.23211 9.46395 8.44018 9.20943 8.44018Z"
                            fill="#5F5F5F"
                          />
                          <path
                            d="M14.025 6.57257V7.19552C13.8192 7.16941 13.6091 7.15624 13.396 7.15624C12.5155 7.15624 11.6879 7.38299 10.9688 7.78082V6.5723C10.9688 6.31778 11.1768 6.10931 11.4317 6.10931H13.5624C13.8166 6.10957 14.025 6.31765 14.025 6.57257Z"
                            fill="#5F5F5F"
                          />
                          <path
                            d="M16.4992 14.4594C16.4992 14.7817 16.2379 15.043 15.9157 15.043C15.5933 15.043 15.332 14.7817 15.332 14.4594C15.332 14.137 15.5933 13.8759 15.9157 13.8759C16.2379 13.8759 16.4992 14.137 16.4992 14.4594Z"
                            fill="#5F5F5F"
                          />
                          <path
                            d="M14.7971 15.4903C14.7971 15.7625 14.5765 15.9831 14.3043 15.9831C14.0321 15.9831 13.8115 15.7625 13.8115 15.4903C13.8115 15.2182 14.0321 14.9976 14.3043 14.9976C14.5765 14.9976 14.7971 15.2182 14.7971 15.4903Z"
                            fill="#5F5F5F"
                          />
                          <path
                            d="M12.828 15.564C12.828 15.8048 12.6329 16 12.392 16C12.1513 16 11.9561 15.8049 11.9561 15.564C11.9561 15.3232 12.1513 15.128 12.392 15.128C12.6329 15.128 12.828 15.3232 12.828 15.564Z"
                            fill="#5F5F5F"
                          />
                          <path
                            d="M11.0761 14.7617C11.0761 14.9109 10.9552 15.0317 10.8061 15.0317C10.6569 15.0317 10.5361 14.9109 10.5361 14.7617C10.5361 14.6127 10.6569 14.4917 10.8061 14.4917C10.9552 14.4917 11.0761 14.6127 11.0761 14.7617Z"
                            fill="#5F5F5F"
                          />
                          <path
                            d="M17.418 12.0706C17.418 12.4719 17.359 12.8594 17.2483 13.2248L16.1061 12.8871C16.2038 12.5878 16.2566 12.2683 16.2566 11.9361C16.2566 11.6048 16.2041 11.2854 16.1066 10.9867C15.9136 10.3942 15.5453 9.88108 15.0631 9.50884C15.0491 9.49771 15.035 9.48709 15.0207 9.47621C14.8068 9.31395 14.5655 9.17523 14.3061 9.06865C14.139 9.00045 13.9642 8.94798 13.7846 8.90933L13.7167 8.89449L13.6485 8.88336C13.6034 8.87568 13.5565 8.86736 13.5146 8.86275L13.4501 8.85533C13.4286 8.85277 13.4088 8.84957 13.3801 8.84868L13.3018 8.84407L13.2628 8.84177L13.2427 8.84062L13.2332 8.8401L13.2286 8.83985H13.2247C12.8557 8.82833 12.4828 8.87772 12.1331 8.98982C11.7803 9.10423 11.4507 9.27621 11.1652 9.4917C10.8802 9.70783 10.6369 9.963 10.4486 10.2349C10.3996 10.302 10.3568 10.3716 10.3141 10.4404C10.2931 10.4751 10.2748 10.5101 10.2551 10.5445C10.235 10.5792 10.2172 10.6145 10.2003 10.6494C10.1282 10.7888 10.0722 10.9309 10.0244 11.0685C10.0017 11.1381 9.97818 11.2058 9.96154 11.2738C9.95322 11.3073 9.9426 11.3408 9.93569 11.3743C9.92801 11.4079 9.92085 11.4409 9.91419 11.4742C9.91074 11.4902 9.90703 11.5068 9.90383 11.5223C9.90063 11.5387 9.89807 11.5549 9.89551 11.5713C9.89039 11.6032 9.88515 11.6355 9.88003 11.6665C9.87056 11.7289 9.86569 11.7872 9.85853 11.8454C9.85341 11.9062 9.85047 11.97 9.84675 12.0289L9.8465 12.0404C9.8465 12.0404 9.8465 12.0427 9.84599 12.0427V12.0453L9.84573 12.0663C9.84522 12.0801 9.84522 12.0938 9.84458 12.107C9.84458 12.1345 9.84407 12.1608 9.84458 12.1869C9.84483 12.291 9.85008 12.3871 9.85802 12.4731C9.87376 12.6453 9.89935 12.7798 9.9188 12.8709C9.92827 12.9165 9.93569 12.9483 9.94196 12.9741C9.94798 12.9988 9.95169 13.0113 9.95169 13.0113L9.59248 13.1142C9.59248 13.1142 9.58852 13.1022 9.58071 13.0775C9.57303 13.0548 9.56011 13.0132 9.54603 12.964C9.53055 12.9089 9.51161 12.8389 9.49331 12.7552C9.45466 12.5328 9.43457 12.3043 9.43457 12.0707C9.43457 9.86613 11.2218 8.07935 13.4266 8.07935C14.4199 8.07935 15.3285 8.44225 16.0268 9.0424C16.3337 9.30614 16.6003 9.61569 16.815 9.96081C17.1972 10.5728 17.418 11.2959 17.418 12.0707L17.418 12.0706Z"
                            fill="#5F5F5F"
                          />
                          <path
                            d="M15.1691 10.9748C15.0995 10.8696 14.9955 10.84 14.8834 10.8948C14.7461 10.9621 14.612 11.0407 14.4826 11.1167L14.4505 11.1356C14.239 11.2603 14.0279 11.3855 13.8167 11.5108C13.6923 11.5848 13.5679 11.6587 13.4435 11.7324C13.3498 11.6903 13.2466 11.6682 13.1439 11.6682C12.9974 11.6682 12.8559 11.7121 12.7346 11.7949C12.6987 11.8196 12.6643 11.8476 12.6326 11.8788C12.3829 12.1259 12.3457 12.5161 12.544 12.8064C12.6797 13.005 12.9044 13.1238 13.1451 13.1238C13.2466 13.1238 13.3452 13.1028 13.4377 13.0621C13.4779 13.0446 13.5175 13.0226 13.5552 12.9967C13.7647 12.8537 13.8848 12.6098 13.8714 12.3573C14.0795 12.1772 14.4077 11.8998 14.6724 11.676C14.91 11.4751 15.0975 11.3165 15.1367 11.2807C15.2309 11.1941 15.2424 11.0855 15.1691 10.9748Z"
                            fill="#5F5F5F"
                          />
                        </svg>
                        <h3
                          style={
                            step.status == "is_scheduled"
                              ? {
                                  color: "rgba(158, 158, 158, 1)",
                                  fontSize: "11px",
                                  fontWeight: "400",
                                  marginRight: "-80px",
                                }
                              : {
                                  color: "rgba(158, 158, 158, 1)",
                                  fontSize: "11px",
                                  fontWeight: "400",
                                }
                          }
                        >
                          {step.modelIdResult && item.startedAt
                            ? new Date(
                                new Date(item.startedAt).toLocaleString(
                                  "en-US",
                                  {
                                    timeZone: "America/Los_Angeles",
                                  }
                                )
                              ).toDateString() +
                              " " +
                              new Date(item.startedAt)
                                .toLocaleString("en-US", {
                                  timeZone: "America/Los_Angeles",
                                })
                                .toString()
                                .substr(11, 5) +
                              " PDT - US & Canada"
                            : "Unspecified"}
                        </h3>
                      </div>
                    )}
                    {step.type == "payment" && isPurchase && (
                      <div
                        style={{ alignItems: "center" }}
                        className={`d-flex flex-row gap-1 ${
                          step.status == "active" ? "col-4" : ""
                        }`}
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="17"
                          height="17"
                          viewBox="0 0 17 17"
                          fill="none"
                        >
                          <path
                            d="M8.5 1C4.35938 1 1 4.35938 1 8.5C1 12.6406 4.35938 16 8.5 16C12.6406 16 16 12.6406 16 8.5C16 4.35938 12.6406 1 8.5 1ZM8.5 1.83333C12.1914 1.83333 15.1667 4.80859 15.1667 8.5C15.1667 12.1914 12.1914 15.1667 8.5 15.1667C4.80859 15.1667 1.83333 12.1914 1.83333 8.5C1.83333 4.80859 4.80859 1.83333 8.5 1.83333ZM8.08333 3.91667V4.82812C7.41602 4.91113 6.20833 5.49544 6.20833 6.91146C6.20833 9.57747 10.0885 8.2054 10.0885 10.2057C10.0885 10.873 9.79232 11.4948 8.5 11.4948C7.20768 11.4948 6.83333 10.5003 6.83333 9.95833H6C6.12533 11.7503 7.37533 12.1637 8.08333 12.2891V13.0833H8.91667V12.2891C9.54167 12.2467 11 11.7943 11 10.1276C11 8.75228 9.87044 8.37305 8.78646 8.1224C7.91081 7.91406 7.11979 7.70898 7.11979 6.83333C7.11979 6.45898 7.28906 5.6224 8.53906 5.6224C9.41471 5.6224 9.83301 6.16602 9.95833 6.83333H10.7917C10.541 5.91699 10.1243 5.08854 8.91667 4.88021V3.91667H8.08333Z"
                            fill="#18324E"
                            stroke="#18324E"
                            stroke-width="0.5"
                          />
                        </svg>
                        <h3
                          style={{
                            color: "#18324E",
                            fontSize: "13px",
                            fontWeight: "600",
                            marginBottom: "0px",
                          }}
                        >
                          {step.price}
                        </h3>
                      </div>
                    )}
                  </div>
                  {/* <p style={{ visibility: "hidden" }}>no content</p> */}
                </div>
              </div>

              {
                <>
                  {isLoading ? <></> : <></>}

                  <div
                    dir={isMobile ? "rtl" : "ltr"}
                    className={isMobile && "col-12 "}
                  >
                    {isPurchase && step.status == "need_admin_approve" ? (
                      <div
                        style={
                          isMobile
                            ? {
                                display: "flex",
                                paddingBottom: "5px",
                              }
                            : {
                                display: "flex",
                                paddingBottom: "5px",
                                justifyContent: "end",
                              }
                        }
                      >
                        <Button
                          onClick={() => {
                            showApproveConfirm();
                          }}
                          style={{
                            color: "rgba(20, 166, 80, 1)",
                            borderRadius: "50px",
                            padding: "8px 10px 8px 10px",
                          }}
                          className="step-button"
                          disabled={
                            privilage.indexOf(
                              access.patientManegment.service.step.approve
                            ) <= -1
                          }
                        >
                          Approve
                        </Button>

                        <Button
                          style={{
                            color: "rgba(239, 29, 45, 1)",
                            borderRadius: "50px",
                            padding: "8px 10px 8px 10px",
                          }}
                          disabled={
                            privilage.indexOf(
                              access.patientManegment.service.step.Reject
                            ) <= -1
                          }
                          className="step-button"
                          onClick={() => {
                            setCurrent({ id: step.id });
                            setOpenReject(true);
                          }}
                        >
                          Decline
                        </Button>
                      </div>
                    ) : (
                      <></>
                    )}

                    <div style={{ display: "flex" }}>
                      {isPurchase && (
                        <>
                          {step.type == "appointment" &&
                            step.status == "active" &&
                            !step.modelIdResult &&
                            privilage.indexOf(
                              access.patientManegment.service.step.generateLink
                            ) > -1 && (
                              <Button
                                onClick={async () => {
                                  setIsLoading(true);
                                  var date = new Date();
                                  var res = await putData(
                                    `admin/service-purchase/${serviceId}/step/${step.id}/appointment/generate-url`,
                                    {
                                      startDate: date,
                                      endDate: date.setDate(
                                        date.getDate() + 30
                                      ),
                                    }
                                  );
                                  if (res.status == 200) {
                                    Modal.success({
                                      title: res.data.message,
                                    });
                                    await getService();
                                  } else {
                                    Modal.error({ title: res });
                                  }
                                  setIsLoading(false);
                                }}
                                style={{
                                  color: statusList[step.status].color,
                                  textDecoration: "none",
                                }}
                                className="step-button"
                                disabled={step.status == "locked" || desible}
                              >
                                Regenerate
                              </Button>
                            )}
                          {step.status != "done" &&
                            step.type == "appointment" &&
                            !step.modelIdResult && (
                              <Button
                                onClick={() => {
                                  getLocation();
                                  setIsOpenAppointment(true);
                                }}
                                disabled={
                                  (!(
                                    step.appointmentUrl &&
                                    privilage.indexOf(
                                      access.patientManegment.service.step
                                        .bookNow
                                    ) > -1
                                  ) &&
                                    step.status != "active") ||
                                  desible
                                }
                                style={{
                                  color: statusList[step.status]
                                    ? statusList[step.status].color
                                    : "rgba(24, 50, 78, 0.3)",
                                  textDecoration: "none",
                                }}
                                className="step-button"
                              >
                                Schedule
                              </Button>
                            )}
                          {step.type == "form" && !step.modelIdResult && (
                            <Button
                              onClick={async () => {
                                await getForm();
                              }}
                              disabled={
                                (!(
                                  step.appointmentUrl &&
                                  privilage.indexOf(
                                    access.patientManegment.service.step.bookNow
                                  ) > -1
                                ) &&
                                  step.status != "active") ||
                                desible
                              }
                              style={{
                                color: statusList[step.status]
                                  ? statusList[step.status].color
                                  : "rgba(24, 50, 78, 0.3)",
                                textDecoration: "none",
                              }}
                              className="step-button"
                              loading={isLoading}
                            >
                              Fill Out Form
                            </Button>
                          )}
                          {step.type == "payment" &&
                            (step.status == "active" ? (
                              <Button
                                onClick={() => {
                                  openPayModal(true);
                                }}
                                style={{
                                  color: step.status
                                    ? statusList[step.status].color
                                    : "rgba(24, 50, 78, 0.3)",
                                  textDecoration: "none",
                                }}
                                className="step-button"
                                disabled={!(step.status == "active") || desible}
                              >
                                {"Checkout"}
                              </Button>
                            ) : (
                              <Button
                                onClick={() => {
                                  setIsPayment(true);
                                }}
                                style={{
                                  color: step.status
                                    ? statusList[step.status].color
                                    : "rgba(24, 50, 78, 0.3)",
                                  textDecoration: "none",
                                }}
                                className="step-button"
                                disabled={
                                  !(
                                    step.status == "done" ||
                                    step.status == "need_admin_approve"
                                  ) || desible
                                }
                              >
                                {"Payment's info"}
                              </Button>
                            ))}
                          {step.type == "document" && (
                            <Button
                              onClick={() => {
                                setisopenupload(!isopenupload);
                                if (!isopenupload) {
                                  fetchDocuments();
                                }
                                setisopenmessage(false);
                                setIsOpen(false);
                                setisopencomment(false);
                              }}
                              style={{
                                color: statusList[step.status]
                                  ? statusList[step.status].color
                                  : "rgba(24, 50, 78, 0.3)",
                                textDecoration: "none",
                              }}
                              className="step-button"
                              disabled={
                                privilage.indexOf(
                                  access.patientManegment.service.step
                                    .showDocument
                                ) <= -1 ||
                                step.status == "locked" ||
                                !step.status ||
                                desible
                              }
                            >
                              Uploaded Files
                            </Button>
                          )}
                          {step.type == "appointment" &&
                            step.status == "is_scheduled" && (
                              <Button
                                href={
                                  item.rescheduleUrl +
                                  "?name=" +
                                  name +
                                  "&email=" +
                                  email +
                                  "&utm_content=" +
                                  JSON.stringify({
                                    patientId: patientId,
                                    purchaseStepId: step.id,
                                    locationType: item.locationType,
                                    redirectUrl:
                                      "https://cpanel.iqliniq.com" +
                                      currentpath.pathname,
                                  })
                                }
                                className="step-button"
                                style={{
                                  textDecoration: "none",
                                  color: step.status
                                    ? statusList[step.status].color
                                    : statusList.locked.color,
                                }}
                                disabled={
                                  privilage.indexOf(
                                    access.patientManegment.service.step
                                      .rescchole
                                  ) <= -1 ||
                                  !step.status ||
                                  desible
                                }
                              >
                                Reschedule
                              </Button>
                            )}
                          {/* {step.type == "appointment" &&
                            step.status == "is_scheduled" && (
                              <Button
                                className="step-button"
                                style={{
                                  textDecoration: "none",
                                  color: step.status
                                    ? statusList[step.status].color
                                    : statusList.locked.color,
                                }}
                                disabled={!step.status || desible}
                                onClick={() => {
                                  setOpenTranslator(true);
                                }}
                              >
                                Add Interpreter
                              </Button>
                            )} */}
                          {step.type == "sign_form" &&
                            step.status == "active" && (
                              <Button
                                className="step-button"
                                disabled={
                                  privilage.indexOf(
                                    access.patientManegment.service.step.sign
                                  ) <= -1 ||
                                  !step.status ||
                                  desible
                                }
                                onClick={async () => {
                                  setCurrent({});
                                  await sendSignform();
                                }}
                              >
                                Send Sign Request
                              </Button>
                            )}
                          {step.type == "sign_form" &&
                            step.status == "need_sign_by_user" && (
                              <Button
                                className="step-button"
                                disabled={
                                  privilage.indexOf(
                                    access.patientManegment.service.step.Resend
                                  ) <= -1 ||
                                  !step.status ||
                                  step.status != "need_sign_by_user" ||
                                  desible
                                }
                                onClick={async () => {
                                  setCurrent({});
                                  await resend(step.modelIdResult);
                                }}
                              >
                                Resend
                              </Button>
                            )}
                          {step.type == "sign_form" &&
                            step.status == "need_sign_by_user" &&
                            privilage.indexOf(
                              access.patientManegment.service.step.preview
                            ) > -1 && (
                              <>
                                <Button
                                  className="step-button"
                                  onClick={async () => {
                                    setCurrent({});
                                    await preview(step.modelIdResult);
                                    setOpenPreview(true);
                                  }}
                                  disabled={
                                    step.status != "need_admin_approve" ||
                                    !step.status ||
                                    desible
                                  }
                                >
                                  Preview
                                </Button>
                              </>
                            )}{" "}
                          <Button
                            onClick={() => {
                              if (step.description) {
                                setIsOpen(!isOpen);
                                setisopenmessage(false);
                                setisopenupload(false);
                                setisopencomment(false);
                              }
                            }}
                            className={
                              isOpen ? "step-button-active" : "step-button"
                            }
                            style={{
                              "--triangle-color": statusList[step.status].color,
                            }}
                            disabled={
                              step.status == "locked" ||
                              !step.status ||
                              !step.description ||
                              desible
                            }
                          >
                            Details
                          </Button>
                          <Button
                            className={
                              isopenmessage
                                ? "step-button-active"
                                : "step-button"
                            }
                            style={{
                              "--triangle-color": statusList[step.status].color,
                            }}
                            onClick={() => {
                              setisopenmessage(!isopenmessage);
                              setIsOpen(false);
                              setisopenupload(false);
                              setisopencomment(false);
                            }}
                            disabled={
                              step.status == "locked" || !step.status || desible
                            }
                            // style={{padding:"8px 10px 8px 10px"}}
                          >
                            Messages
                          </Button>
                          <Button
                            loading={isLoading}
                            className={
                              isopencomment
                                ? "step-button-active"
                                : "step-button"
                            }
                            style={{
                              "--triangle-color": statusList[step.status].color,
                            }}
                            onClick={async () => {
                              if (!isopencomment && comments.length == 0) {
                                await getComments();
                              }
                              setisopencomment(!isopencomment);
                              setIsOpen(false);
                              setisopenupload(false);
                              setisopenmessage(false);
                            }}
                            disabled={
                              step.status == "locked" || !step.status || desible
                            }
                            // style={{padding:"8px 10px 8px 10px"}}
                          >
                            Comments
                          </Button>
                          {isMobile && (
                            <Button
                              onClick={() => {
                                step.hide ? unHide() : hide();
                              }}
                              loading={isLoading}
                              className="step-button"
                              disabled={
                                privilage.indexOf(
                                  access.patientManegment.service.step.approve
                                ) <= -1 || desible
                              }
                            >
                              {step.hide ? "Show" : "Hide"}
                            </Button>
                          )}
                        </>
                      )}
                    </div>
                  </div>
                </>
              }
            </>
          </div>
        </div>

        {isOpen && (
          <div className="d-flex flex-row">
            <div style={{ justifyContent: "center" }} className="col-1 d-flex">
              {!isLast && <div style={{ height: "100%" }} className="v-line" />}
            </div>
            <div className="desc-box ">
              {step.needUserApproved && step.status == "active" && (
                <div dir="rtl" className="col-12">
                  <Button
                    color={statusList[step.status].color}
                    type="primary"
                    size="small"
                    onClick={approveByUser}
                  >
                    Approve By User
                  </Button>
                </div>
              )}
              <p>{step.description}</p>
            </div>
          </div>
        )}
        {isopenmessage && (
          <div className="d-flex flex-row">
            <div style={{ justifyContent: "center" }} className="col-1 d-flex">
              {!isLast && <div style={{ height: "100%" }} className="v-line" />}
            </div>
            <div className="desc-box ">
              <div style={{ maxHeight: "50vh", overflowY: "scroll" }}>
                {isLoading ? (
                  <div style={{ display: "flex", justifyContent: "center" }}>
                    <Spin size="large" />
                  </div>
                ) : (
                  reply.length > 0 &&
                  reply.map((temp, index) => {
                    const monthNames = [
                      "January",
                      "February",
                      "March",
                      "April",
                      "May",
                      "June",
                      "July",
                      "August",
                      "September",
                      "October",
                      "November",
                      "December",
                    ];
                    var date = new Date(temp.createdAt);
                    var day = date.getDate();
                    var month = monthNames[date.getMonth()];
                    var year = date.getFullYear();

                    if (index > 0) {
                      var prevdate = new Date(reply[index - 1].createdAt);
                      var prevday = prevdate.getDate();
                      var prevdaymonth = monthNames[prevdate.getMonth()];
                      var prevyear = prevdate.getFullYear();
                    }
                    if (temp.senderId != userId) {
                      if (
                        prevday == day &&
                        prevyear == year &&
                        prevdaymonth == month &&
                        index > 0
                      ) {
                        return (
                          <ChatBubbles
                            sender={true}
                            subject={temp.subject ? temp.subject : ""}
                            message={temp.message}
                            name={
                              temp.sender
                                ? temp.sender.firstName +
                                  " " +
                                  temp.sender.lastName
                                : "system reply"
                            }
                            time={temp.createdAt}
                            id={temp.id}
                            Delete={deleteReply}
                            Edit={editReply}
                          />
                        );
                      } else {
                        if (prevyear != year) {
                          return (
                            <div>
                              <div
                                style={{
                                  textAlign: "center",
                                  fontSize: "10px",
                                  color: "#5f5f5f",
                                  fontWeight: "bold",
                                }}
                              >
                                {month}
                                {" " + day} ,{year}
                              </div>
                              <ChatBubbles
                                sender={true}
                                subject={temp.subject ? temp.subject : ""}
                                message={temp.message}
                                name={
                                  temp.sender
                                    ? temp.sender.firstName +
                                      " " +
                                      temp.sender.lastName
                                    : "system reply"
                                }
                                time={temp.createdAt}
                                id={temp.id}
                                Delete={deleteReply}
                                Edit={editReply}
                              />
                            </div>
                          );
                        } else {
                          return (
                            <div>
                              <div
                                style={{
                                  textAlign: "center",
                                  fontSize: "12px",
                                  color: "#5f5f5f",
                                  fontWeight: "bold",
                                }}
                              >
                                {month}
                                {" " + day}{" "}
                              </div>
                              <ChatBubbles
                                subject={temp.subject ? temp.subject : ""}
                                message={temp.message}
                                name={
                                  temp.sender
                                    ? temp.sender.firstName +
                                      " " +
                                      temp.sender.lastName
                                    : "system reply"
                                }
                                time={temp.createdAt}
                                id={temp.id}
                                Delete={deleteReply}
                                Edit={editReply}
                              />
                            </div>
                          );
                        }
                      }
                    } else {
                      if (
                        prevday == day &&
                        prevyear == year &&
                        prevdaymonth == month &&
                        index > 0
                      ) {
                        return (
                          <ChatBubbles
                            subject={temp.subject ? temp.subject : ""}
                            message={temp.message}
                            // sender={true}
                            time={temp.createdAt}
                            id={temp.id}
                            Delete={deleteReply}
                            Edit={editReply}
                          />
                        );
                      } else {
                        if (prevyear != year || index == 0) {
                          return (
                            <div>
                              <div
                                style={{
                                  textAlign: "center",
                                  fontSize: "12px",
                                  color: "#5f5f5f",
                                  fontWeight: "bold",
                                }}
                              >
                                {month}
                                {" " + day} ,{year}
                              </div>
                              <ChatBubbles
                                subject={temp.subject ? temp.subject : ""}
                                message={temp.message}
                                // sender={true}
                                time={temp.createdAt}
                                id={temp.id}
                                Delete={deleteReply}
                                Edit={editReply}
                              />
                            </div>
                          );
                        } else {
                          return (
                            <div>
                              <div
                                style={{
                                  textAlign: "center",
                                  fontSize: "12px",
                                  color: "#5f5f5f",
                                  fontWeight: "bold",
                                }}
                              >
                                {month}
                                {" " + day}{" "}
                              </div>

                              <ChatBubbles
                                subject={temp.subject ? temp.subject : ""}
                                message={temp.message}
                                sender={true}
                                time={temp.createdAt}
                                id={temp.id}
                                Delete={deleteReply}
                                Edit={editReply}
                              />
                            </div>
                          );
                        }
                      }
                    }
                  })
                )}
              </div>
              <div class="message-box">
                {/* <textarea
                  type="text"
                  class="message-input"
                  placeholder="Type message..."
                  value={replyText}
                  onKeyDown={(e) => {
                    if (e.key == "Enter" && !e.shiftKey) {
                      if (replyText) {
                        sendReply(current);
                        setReplyText("");
                      }
                    }
                  }}
                  onChange={(e) => {
                    setReplyText(e.target.value);
                    setCurrent({
                      ...current,
                      message: e.target.value,
                      subject: null,
                    });
                  }}
                ></textarea> */}

                <ReactQuill
                  className="message-input"
                  ref={quillRef}
                  value={replyText}
                  formats={formats}
                  modules={modules}
                  onChange={handleChange}
                />
                <div className="message-submit">
                  {" "}
                  <Button
                    className="templateButton"
                    onClick={() => {
                      setIsOpenTemplate(true);
                    }}
                  >
                    Choose Email Template
                  </Button>
                  <button
                    type="submit"
                    onClick={() => {
                      if (replyText) {
                        sendReply(current);
                        setReplyText("");
                      }
                    }}
                    style={{ backgroundColor: "inherit" }}
                  >
                    <svg
                      width="32"
                      height="32"
                      viewBox="0 0 32 32"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M16 0C7.1776 0 0 7.1776 0 16C0 24.8224 7.1776 32 16 32C24.8224 32 32 24.8224 32 16C32 7.1776 24.8224 0 16 0ZM21.2688 17.1312L17.6 13.4624V24H14.4V13.4624L10.7312 17.1312L8.4688 14.8688L16 7.3376L23.5312 14.8688L21.2688 17.1312Z"
                        fill="#81C047"
                      />
                    </svg>
                  </button>
                </div>
              </div>
            </div>
          </div>
        )}
        {isopenupload && (
          <div className="d-flex flex-row">
            <div style={{ justifyContent: "center" }} className="col-1 d-flex">
              {!isLast && <div style={{ height: "100%" }} className="v-line" />}
            </div>
            <div className="desc-box ">
              {/* {console.log(step)} */}
              <div
                style={{
                  display: "flex",
                  justifyContent: "end",
                  alignItems: "center",
                }}
              >
                <button
                  onClick={() => {
                    setisopennewupload(true);
                  }}
                  style={{
                    backgroundColor: "rgba(207, 232, 255, 1)",
                    padding: "5px",
                    fontWeight: "bold",
                    borderRadius: "5px",
                    marginBottom: "5px",
                  }}
                >
                  <svg
                    width="12"
                    height="13"
                    viewBox="0 0 12 13"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M5.98913 1.68905C5.77709 1.69216 5.57496 1.77932 5.42715 1.93137C5.27934 2.08343 5.19795 2.28795 5.20085 2.49999V5.69999H2.00085C1.89484 5.69849 1.78959 5.71807 1.69121 5.75761C1.59284 5.79714 1.5033 5.85582 1.42781 5.93026C1.35231 6.0047 1.29236 6.09339 1.25144 6.1912C1.21052 6.28901 1.18945 6.39397 1.18945 6.49999C1.18945 6.60601 1.21052 6.71097 1.25144 6.80878C1.29236 6.90658 1.35231 6.99528 1.42781 7.06972C1.5033 7.14415 1.59284 7.20284 1.69121 7.24237C1.78959 7.2819 1.89484 7.30149 2.00085 7.29999H5.20085V10.5C5.19935 10.606 5.21893 10.7112 5.25846 10.8096C5.298 10.908 5.35668 10.9975 5.43112 11.073C5.50555 11.1485 5.59425 11.2085 5.69206 11.2494C5.78986 11.2903 5.89483 11.3114 6.00085 11.3114C6.10687 11.3114 6.21183 11.2903 6.30964 11.2494C6.40744 11.2085 6.49614 11.1485 6.57058 11.073C6.64501 10.9975 6.7037 10.908 6.74323 10.8096C6.78276 10.7112 6.80235 10.606 6.80085 10.5V7.29999H10.0008C10.1069 7.30149 10.2121 7.2819 10.3105 7.24237C10.4089 7.20284 10.4984 7.14415 10.5739 7.06972C10.6494 6.99528 10.7093 6.90658 10.7503 6.80878C10.7912 6.71097 10.8122 6.60601 10.8122 6.49999C10.8122 6.39397 10.7912 6.28901 10.7503 6.1912C10.7093 6.09339 10.6494 6.0047 10.5739 5.93026C10.4984 5.85582 10.4089 5.79714 10.3105 5.75761C10.2121 5.71807 10.1069 5.69849 10.0008 5.69999H6.80085V2.49999C6.80231 2.39302 6.78231 2.28685 6.74202 2.18775C6.70174 2.08865 6.64199 1.99864 6.56631 1.92303C6.49063 1.84742 6.40056 1.78776 6.30142 1.74757C6.20228 1.70738 6.09609 1.68748 5.98913 1.68905Z"
                      fill="#18324E"
                    />
                  </svg>
                  New File
                </button>
              </div>
              {/* <Table
                columns={columns}
                dataSource={data}
                loading={isLoading}
                pagination={{
                  position: ["none", "none"],
                }}
              /> */}
              {isLoading ? (
                <div style={{ display: "flex", justifyContent: "center" }}>
                  <Spin color={"#18324e"} style={{ fontSize: "16px" }} />
                </div>
              ) : (
                <table style={{ width: "100%" }}>
                  <thead>
                    <tr>
                      <th>Description</th>
                      <th>Category</th>
                      <th>File Name</th>
                      {<th>Last Modified</th>}
                      <th></th>
                      <th></th>
                    </tr>
                  </thead>
                  <tbody>
                    {data.length == 0 ? (
                      <div style={{ textAlign: "center" }}>no file exist</div>
                    ) : (
                      data.map((temp, i) => {
                        var date = new Date(temp.updatedAt);
                        var year = date.getFullYear();
                        var month = date.getMonth() + 1;
                        var day = date.getDate();

                        if (i + 1 == data.length) {
                          return (
                            <>
                              <tr>
                                <td>{temp.description}</td>
                                <td>
                                  {categoris.map((tempcategory) => {
                                    if (tempcategory.id == temp.categoryId) {
                                      return tempcategory.title;
                                    }
                                  })}
                                </td>
                                <td>
                                  <a href={temp.url} target="_blank">
                                    {temp.title}
                                  </a>
                                </td>
                                {<td>{year + "-" + month + "-" + day}</td>}
                                <td>
                                  {" "}
                                  <svg
                                    width="17"
                                    height="17"
                                    viewBox="0 0 17 17"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                    onClick={() => handleShowModal(temp)}
                                  >
                                    <path
                                      d="M14.1504 0C13.5171 0 12.8838 0.241172 12.4004 0.724609L11.375 1.75L14.875 5.25L15.9004 4.22461C16.8664 3.25861 16.8664 1.69148 15.9004 0.724609C15.417 0.241172 14.7837 0 14.1504 0ZM10.0625 3.0625L0 13.125V16.625H3.5L13.5625 6.5625L10.0625 3.0625Z"
                                      fill="#18324E"
                                    />
                                  </svg>
                                </td>

                                <td>
                                  {" "}
                                  <svg
                                    width="20"
                                    height="20"
                                    viewBox="0 0 20 20"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                    onClick={async () => {
                                      await removeDocument(temp.id);
                                      fetchDocuments();
                                    }}
                                  >
                                    <path
                                      d="M10 0C4.48618 0 0 4.48618 0 10C0 15.5138 4.48618 20 10 20C15.5138 20 20 15.5138 20 10C20 4.48618 15.5138 0 10 0ZM10 1.53846C14.6815 1.53846 18.4615 5.31851 18.4615 10C18.4615 14.6815 14.6815 18.4615 10 18.4615C5.31851 18.4615 1.53846 14.6815 1.53846 10C1.53846 5.31851 5.31851 1.53846 10 1.53846ZM5.38462 9.23077V10.7692H14.6154V9.23077H5.38462Z"
                                      fill="#18324E"
                                    />
                                  </svg>
                                </td>
                              </tr>
                            </>
                          );
                        } else {
                          return (
                            <>
                              <tr style={{ borderBottom: "solid black 1px" }}>
                                <td>{temp.description}</td>
                                <td>
                                  {categoris.map((tempcategory) => {
                                    if (tempcategory.id == temp.categoryId) {
                                      return tempcategory.title;
                                    }
                                  })}
                                </td>
                                <td>
                                  <a href={temp.url} target="_blank">
                                    {temp.title}
                                  </a>
                                </td>
                                {<td>{year + "-" + month + "-" + day}</td>}
                                <td>
                                  {" "}
                                  <svg
                                    width="17"
                                    height="17"
                                    viewBox="0 0 17 17"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                    onClick={() => handleShowModal(temp)}
                                  >
                                    <path
                                      d="M14.1504 0C13.5171 0 12.8838 0.241172 12.4004 0.724609L11.375 1.75L14.875 5.25L15.9004 4.22461C16.8664 3.25861 16.8664 1.69148 15.9004 0.724609C15.417 0.241172 14.7837 0 14.1504 0ZM10.0625 3.0625L0 13.125V16.625H3.5L13.5625 6.5625L10.0625 3.0625Z"
                                      fill="#18324E"
                                    />
                                  </svg>
                                </td>
                                <td>
                                  {" "}
                                  <svg
                                    width="20"
                                    height="20"
                                    viewBox="0 0 20 20"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                    onClick={async () => {
                                      await removeDocument(temp.id);
                                      fetchDocuments();
                                    }}
                                  >
                                    <path
                                      d="M10 0C4.48618 0 0 4.48618 0 10C0 15.5138 4.48618 20 10 20C15.5138 20 20 15.5138 20 10C20 4.48618 15.5138 0 10 0ZM10 1.53846C14.6815 1.53846 18.4615 5.31851 18.4615 10C18.4615 14.6815 14.6815 18.4615 10 18.4615C5.31851 18.4615 1.53846 14.6815 1.53846 10C1.53846 5.31851 5.31851 1.53846 10 1.53846ZM5.38462 9.23077V10.7692H14.6154V9.23077H5.38462Z"
                                      fill="#18324E"
                                    />
                                  </svg>
                                </td>
                              </tr>
                            </>
                          );
                        }
                      })
                    )}
                  </tbody>
                </table>
              )}
            </div>
          </div>
        )}
        {isopencomment && (
          <div className="d-flex flex-row">
            <div style={{ justifyContent: "center" }} className="col-1 d-flex">
              {!isLast && <div style={{ height: "100%" }} className="v-line" />}
            </div>
            <div
              style={{ maxHeight: "250px", overflowY: "scroll" }}
              className="desc-box "
            >
              {privilage.indexOf(access.todoList.addComment) > -1 && (
                <div
                  style={{
                    display: "flex",
                    justifyContent: "end",
                    alignItems: "center",
                  }}
                >
                  <button
                    onClick={() => {
                      setDefult({
                        patientId: patientId,
                        purchaseStepId: step.id,
                        purchaseId: parseInt(serviceId),
                        patient: patient,
                      });
                      setisopennewcomment(true);
                    }}
                    style={{
                      backgroundColor: "rgba(207, 232, 255, 1)",
                      padding: "5px",
                      fontWeight: "bold",
                      borderRadius: "5px",
                      marginBottom: "5px",
                    }}
                  >
                    <svg
                      width="12"
                      height="13"
                      viewBox="0 0 12 13"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M5.98913 1.68905C5.77709 1.69216 5.57496 1.77932 5.42715 1.93137C5.27934 2.08343 5.19795 2.28795 5.20085 2.49999V5.69999H2.00085C1.89484 5.69849 1.78959 5.71807 1.69121 5.75761C1.59284 5.79714 1.5033 5.85582 1.42781 5.93026C1.35231 6.0047 1.29236 6.09339 1.25144 6.1912C1.21052 6.28901 1.18945 6.39397 1.18945 6.49999C1.18945 6.60601 1.21052 6.71097 1.25144 6.80878C1.29236 6.90658 1.35231 6.99528 1.42781 7.06972C1.5033 7.14415 1.59284 7.20284 1.69121 7.24237C1.78959 7.2819 1.89484 7.30149 2.00085 7.29999H5.20085V10.5C5.19935 10.606 5.21893 10.7112 5.25846 10.8096C5.298 10.908 5.35668 10.9975 5.43112 11.073C5.50555 11.1485 5.59425 11.2085 5.69206 11.2494C5.78986 11.2903 5.89483 11.3114 6.00085 11.3114C6.10687 11.3114 6.21183 11.2903 6.30964 11.2494C6.40744 11.2085 6.49614 11.1485 6.57058 11.073C6.64501 10.9975 6.7037 10.908 6.74323 10.8096C6.78276 10.7112 6.80235 10.606 6.80085 10.5V7.29999H10.0008C10.1069 7.30149 10.2121 7.2819 10.3105 7.24237C10.4089 7.20284 10.4984 7.14415 10.5739 7.06972C10.6494 6.99528 10.7093 6.90658 10.7503 6.80878C10.7912 6.71097 10.8122 6.60601 10.8122 6.49999C10.8122 6.39397 10.7912 6.28901 10.7503 6.1912C10.7093 6.09339 10.6494 6.0047 10.5739 5.93026C10.4984 5.85582 10.4089 5.79714 10.3105 5.75761C10.2121 5.71807 10.1069 5.69849 10.0008 5.69999H6.80085V2.49999C6.80231 2.39302 6.78231 2.28685 6.74202 2.18775C6.70174 2.08865 6.64199 1.99864 6.56631 1.92303C6.49063 1.84742 6.40056 1.78776 6.30142 1.74757C6.20228 1.70738 6.09609 1.68748 5.98913 1.68905Z"
                        fill="#18324E"
                      />
                    </svg>
                    New Comment
                  </button>
                </div>
              )}

              {isLoading ? (
                <div style={{ display: "flex", justifyContent: "center" }}>
                  <Spin color={"#18324e"} style={{ fontSize: "16px" }} />
                </div>
              ) : (
                comments.map((comment) => {
                  return (
                    <CommentCard
                      comment={comment}
                      getComments={getComments}
                      Users={users}
                      filter={null}
                      purchase={[
                        {
                          id: parseInt(serviceId),
                          service: { title: serviceName },
                          patient: patient,
                        },
                      ]}
                      setDefult={setDefult}
                      openAddComment={setisopennewcomment}
                    />
                  );
                })
              )}
            </div>
          </div>
        )}
        <Modal
          open={isOpenAppointment}
          onCancel={() => {
            setIsOpenAppointment(false);
            setChangeLocation(false);
            setCopyLink(false);
          }}
          footer={null}
          destroyOnClose
        >
          <div className="d-flex flex-column px-3 gap-4 py-4 w-100 align-items-center">
            <h2 style={{ fontSize: "20px", fontWeight: "700" }}>
              Choose your preferred type of appointment
            </h2>
            <div className="d-flex flex-column gap-2 w-100 justify-content-center align-items-center">
              {isLoading ? (
                <Spin />
              ) : (
                locations.map((l) => {
                  return (
                    <div className="d-flex flex-row gap-1 w-75">
                      <input
                        type="radio"
                        onChange={(e) => {
                          setLocation(e.target.value);
                          setChangeLocation(true);
                        }}
                        key={l.type}
                        value={l.type}
                        name={"locations"}
                      />
                      <label>{l.type}</label>
                    </div>
                  );
                })
              )}
              <Button
                // onClick={() => {
                //   var link = document.createElement("a");
                //   link.href =
                //     step.appointmentUrl +
                //     "?name=" +
                //     name +
                //     "&email=" +
                //     email +
                //     "&utm_content=" +
                //     JSON.stringify({
                //       patientId: patientId,
                //       purchaseStepId: step.id,
                //       locationType: location,
                //       redirectUrl:
                //         "https://cpanel.iqliniq.com" + currentpath.pathname,
                //     });
                //   link.click();
                // }}
                type="primary"
                className="col-5"
              >
                <a
                  style={{ textDecoration: "none" }}
                  href={
                    step.appointmentUrl +
                    "?name=" +
                    name +
                    "&email=" +
                    email +
                    "&utm_content=" +
                    JSON.stringify({
                      patientId: patientId,
                      purchaseStepId: step.id,
                      locationType: location,
                      redirectUrl:
                        "https://cpanel.iqliniq.com" + currentpath.pathname,
                    })
                  }
                >
                  Set Appointment
                </a>
              </Button>
              {changeLocation && (
                <Button
                  onClick={() => {
                    navigator.clipboard.writeText(
                      `${
                        step.appointmentUrl
                      }?name=${name}&email=${email}&utm_content=${JSON.stringify(
                        {
                          patientId: patientId,
                          purchaseStepId: step.id,
                          locationType: location,
                        }
                      )}`
                    );
                    setCopyLink(true);
                  }}
                >
                  {copyLink ? "Copied" : "Copy Link"}
                </Button>
              )}
            </div>
          </div>
        </Modal>
        <Modal
          open={openReply}
          onCancel={() => {
            setOpenReply(false);
            setCurrent({});
          }}
          footer={null}
        >
          <div className="d-flex flex-column gap-3 justify-content-center align-items-center  py-3">
            <h1 style={{ fontSize: "22px", fontWeight: "700" }}>Reply</h1>
            <div className="d-flex flex-column gap-1 col-12 px-4">
              <span style={{ fontSize: "18px" }}>
                <strong>Service: </strong> {serviceName}
              </span>
              <span style={{ fontSize: "18px" }}>
                <strong>Step: </strong> {step.title}
              </span>
            </div>
            <div className="h-line" />
            <div className="d-flex flex-column gap-1 col-12 px-4">
              <Form labelCol={{ span: 6 }} size="large">
                <Form.Item
                  label="Subject"
                  name="subject"
                  rules={[
                    { required: true, message: "Please enter a subject!" },
                  ]}
                >
                  <Input
                    onChange={(e) => {
                      setCurrent({ ...current, subject: e.target.value });
                    }}
                  />
                </Form.Item>
                <Form.Item
                  label="Message"
                  name="message"
                  rules={[
                    { required: true, message: "Please enter the message!" },
                  ]}
                >
                  <Input.TextArea
                    onChange={(e) => {
                      setCurrent({ ...current, message: e.target.value });
                    }}
                  />
                </Form.Item>
                <Form.Item wrapperCol={{ offset: 11, span: 14 }}>
                  <Button
                    loading={isLoading}
                    onClick={() => {
                      sendReply(current);
                    }}
                    size="large"
                    htmlType="submit"
                    type="primary"
                  >
                    Send
                  </Button>
                </Form.Item>
              </Form>
            </div>
          </div>
        </Modal>
        <Modal
          open={openEditReply}
          onCancel={() => {
            setEditReply(false);
          }}
          footer={null}
        >
          <div className="d-flex flex-column gap-3 justify-content-center align-items-center  py-3">
            <h1 style={{ fontSize: "22px", fontWeight: "700" }}>Edit Reply</h1>
            <div className="d-flex flex-column gap-1 col-12 px-4">
              <span style={{ fontSize: "18px" }}>
                <strong>Service: </strong> {serviceName}
              </span>
              <span style={{ fontSize: "18px" }}>
                <strong>Step: </strong> {step.title}
              </span>
            </div>
            <div className="h-line" />
            <div className="d-flex flex-column gap-1 col-12 px-4">
              <Form
                labelCol={{ span: 6 }}
                size="large"
                initialValues={
                  current
                    ? {
                        subject: current.subject,
                        message: current.message,
                      }
                    : {}
                }
              >
                <Form.Item
                  label="Subject"
                  name="subject"
                  rules={[
                    { required: true, message: "Please enter a subject!" },
                  ]}
                >
                  <Input
                    onChange={(e) => {
                      setCurrent({ ...current, subject: e.target.value });
                    }}
                  />
                </Form.Item>
                <Form.Item
                  label="Message"
                  name="message"
                  rules={[
                    { required: true, message: "Please enter a message!" },
                  ]}
                >
                  <Input.TextArea
                    onChange={(e) => {
                      setCurrent({ ...current, message: e.target.value });
                    }}
                  />
                </Form.Item>
                <Form.Item wrapperCol={{ offset: 11, span: 14 }}>
                  <Button
                    loading={isLoading}
                    onClick={() => {
                      editReply(current);
                    }}
                    size="large"
                    htmlType="submit"
                    type="primary"
                  >
                    Edit
                  </Button>
                </Form.Item>
              </Form>
            </div>
          </div>
        </Modal>
        <Modal
          open={isOpenStatus}
          onCancel={() => {
            setIsOpenStatus(false);
          }}
          footer={null}
        >
          <div className="d-flex flex-column gap-3 justify-content-center align-items-center  py-3">
            <h1 style={{ fontSize: "22px", fontWeight: "700" }}>SetStatus</h1>
            <div
              id={step.id}
              style={{ height: "86px", width: "300px", marginRight: "10px" }}
              className="d-flex flex-row"
            >
              <div
                style={{ alignItems: "center", justifyContent: "center" }}
                className="d-flex flex-column "
              ></div>
              <div
                style={
                  isPurchase
                    ? step.status == "done"
                      ? {
                          background:
                            "linear-gradient(to right, #7EFE1B , #4FB600)",
                        }
                      : step.status == "active"
                      ? {
                          background:
                            "linear-gradient(to right, #00E0EE , #028BC6)",
                        }
                      : step.status == "is_scheduled"
                      ? {
                          background:
                            "linear-gradient(to right, #FFD744 , #EDBA00)",
                        }
                      : step.status == "missed"
                      ? {
                          background:
                            "linear-gradient(to right, #FF2727 , #B70202)",
                        }
                      : step.status == "need_admin_approve" ||
                        step.status == "choose_payment_method"
                      ? {
                          background:
                            "linear-gradient(to right, #FF9B26 , #ED8000)",
                        }
                      : { background: "rgba(95, 95, 95, 0.05" }
                    : {
                        background:
                          "linear-gradient(to right, #C0C0C0 , #7F7F7F)",
                      }
                }
                className={
                  isMobile
                    ? "step-box d-flex flex-row col-12"
                    : "step-box d-flex flex-row col-11"
                }
              >
                <>
                  <div className={isMobile ? `col-12` : "col-5"}>
                    <h2
                      className={`title col-12`}
                      style={
                        step.status == "locked"
                          ? { color: "rgba(24, 50, 78, 0.40)" }
                          : {}
                      }
                    >
                      {step.title.length > 40 ? (
                        <span title={step.title}>
                          {step.title.substring(0, 38)}...
                        </span>
                      ) : (
                        <span>{step.title}</span>
                      )}
                    </h2>
                    {step.approvedBy && <p>Approved By: {step.approvedBy}</p>}
                  </div>
                </>
              </div>
            </div>
            <div className="d-flex gap-1 col-12 px-4">
              <span
                className="col-4"
                style={{ fontSize: "16px", fontWeight: "600" }}
              >
                Status:
              </span>
              <Select
                disabled={!isEdit || desible}
                defaultValue={step.status}
                onChange={(v) => {
                  setNeedUpdate([
                    ...needUpdate,
                    { stepId: step.id, status: v },
                  ]);
                }}
                className="col-6"
              >
                <Select.Option value={"done"}>Done</Select.Option>
                <Select.Option value={"locked"}>Locked</Select.Option>
                <Select.Option value={"missed"}>Missed</Select.Option>
                <Select.Option value={"active"}>Active</Select.Option>
                <Select.Option value={"no_show"}>No show</Select.Option>
                <Select.Option value={"need_admin_approve"}>
                  Need admin approve
                </Select.Option>
                <Select.Option value={"is_scheduled"}>
                  Is scheduled
                </Select.Option>
              </Select>
            </div>
            <Button
              onClick={() => setIsOpenStatus(false)}
              type="primary"
              size="large"
              style={{
                fontSize: "14px",
                width: "120px",
                height: "40px",
                marginTop: "15px",
              }}
            >
              Confirm
            </Button>
          </div>
        </Modal>
        <Modal
          open={openReject}
          onCancel={() => {
            setOpenReject(false);
            setCurrent({});
          }}
          footer={null}
        >
          <div className="d-flex flex-column gap-3 justify-content-center align-items-center  py-3">
            <h1 style={{ fontSize: "22px", fontWeight: "700" }}>Decline</h1>
            <div className="d-flex justify-content-center align-items-center col-12 px-4">
              <span style={{ fontSize: "18px" }}>
                Please specify the reason for declining this step.
              </span>
            </div>
            <div className="h-line" />
            <div className="d-flex flex-column gap-1 col-12 px-4">
              <Form labelCol={{ span: 6 }} size="large" form={form}>
                <Form.Item
                  label="Subject"
                  name="subject"
                  rules={[
                    { required: true, message: "Please enter a subject!" },
                  ]}
                >
                  <Input
                    onChange={(e) => {
                      setCurrent({ ...current, subject: e.target.value });
                    }}
                  />
                </Form.Item>
                <Form.Item
                  label="Message"
                  name="message"
                  rules={[
                    { required: true, message: "Please enter  message!" },
                  ]}
                >
                  <Input.TextArea
                    onChange={(e) => {
                      setCurrent({ ...current, message: e.target.value });
                    }}
                  />
                </Form.Item>
                <Form.Item wrapperCol={{ offset: 11, span: 14 }}>
                  <Button
                    loading={isLoading}
                    onClick={() => {
                      reject(current);
                    }}
                    size="large"
                    htmlType="submit"
                    type="primary"
                  >
                    Send
                  </Button>
                </Form.Item>
              </Form>
            </div>
          </div>
        </Modal>
        <Modal
          open={openPreview}
          onCancel={() => {
            setOpenPreview(false);
            setCurrent({});
          }}
          footer={null}
        >
          <div className="d-flex flex-column gap-3 justify-content-center align-items-center  py-3">
            <h1 style={{ fontSize: "22px", fontWeight: "700" }}>Preview</h1>
            <div className="d-flex justify-content-center align-items-center col-12 px-4">
              <span style={{ fontSize: "18px" }}>
                The preview link for the sign form is only valid for 30 minutes.
              </span>
            </div>
            <div className="h-line" />
            <div className="d-flex flex-row gap-1 col-12 px-4">
              <Form labelCol={{ span: 8 }} size="large">
                <Form.Item label="Password" name="password">
                  <Tag>{current.password}</Tag>
                </Form.Item>
              </Form>
              <a
                style={{ marginTop: "5px", marginLeft: "25px" }}
                href={current.url}
              >
                Redirect to Sign Form{" "}
                <svg
                  style={{ marginLeft: "5px" }}
                  width="7"
                  height="13"
                  viewBox="0 0 7 13"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M6.99475 6.3833C6.97009 6.12764 6.86674 5.88588 6.69912 5.69131L2.21682 0.466058C2.00595 0.203107 1.69727 0.0370092 1.36154 0.00542641C1.02577 -0.0259886 0.691595 0.0798874 0.435553 0.299099C0.179346 0.518137 0.0230171 0.831755 0.0023443 1.16797C-0.0183258 1.50434 0.0984027 1.83464 0.325772 2.08351L4.11558 6.5L0.325772 10.9165C0.0983983 11.1654 -0.0183285 11.4957 0.0023443 11.832C0.0230144 12.1682 0.179346 12.4818 0.435553 12.7009C0.691586 12.9201 1.02577 13.026 1.36154 12.9946C1.6973 12.963 2.00596 12.7969 2.21682 12.5339L6.69912 7.30869C6.91902 7.05303 7.02567 6.71907 6.99475 6.38343V6.3833Z"
                    fill="#2E6CDF"
                  />
                </svg>
              </a>
            </div>
          </div>
        </Modal>
        <Modal
          open={isOpenEditUrl}
          onOk={async () => {
            setIsLoading(true);
            var res = await putData(
              "admin/appointment/" + step.modelIdResult,
              item
            );
            if (res.status == 200) {
              setIsOpenEditUrl(false);
              fetchItem();
              Modal.success({ title: res.data.message });
            } else {
              Modal.error({ title: res });
            }
            setIsLoading(false);
          }}
          confirmLoading={isLoading}
          onCancel={() => {
            setIsOpenEditUrl(false);
          }}
        >
          <div className="d-flex flex-column gap-3 px-4 col-12 align-items-center justify-content-center">
            <h2 style={{ fontSize: "22px", fontWeight: "700" }}>
              Appointment information
            </h2>
            <Form labelCol={{ span: 6 }} className="col-10" size="middle">
              <FormItem label="URL">
                <Input
                  value={item.location}
                  onChange={(e) => {
                    setItem({ ...item, location: e.target.value });
                  }}
                />
              </FormItem>
              <FormItem label="Started At">
                <Input
                  value={item.startedAt}
                  onChange={(e) => {
                    setItem({ ...item, startedAt: e.target.value });
                  }}
                />
              </FormItem>
              <FormItem label="Finished At">
                <Input
                  value={item.finishedAt}
                  onChange={(e) => {
                    setItem({ ...item, finishedAt: e.target.value });
                  }}
                />
              </FormItem>
            </Form>
          </div>
        </Modal>
        <Modal
          open={isopeneditupload}
          onCancel={() => setisopeneditupload(false)}
          footer={(null, null)}
          width={"45vw"}
          style={{ top: "5vh" }}
        >
          <div className="myModal d-flex flex-column justify-content-center gap-3 px-3">
            <h1>Edit Documents</h1>
            <div className="line" />
            <h2
              style={{
                fontSize: "18px",
                fontWeight: "700",
                color: "#18324e",
                marginBottom: "15px",
                marginTop: "-15px",
              }}
            >
              {document.title}
            </h2>
            <CustomInput
              label={"Description"}
              fullWidth
              value={document.description}
              onChange={(e) => setDocument({ ...document, description: e })}
            />
            <div className="mx-2">
              <FileUploader
                required
                handleChange={(file) =>
                  setDocument({ ...document, file: file })
                }
                name="file"
                types={["JPG", "PNG", "PDF", "mp4", "mov", "document", "docx"]}
                maxSize={50}
                classes="up_doc"
              />
            </div>
            <Button
              type="primary"
              className="col-3 mx-2"
              onClick={editDocument}
              loading={isLoading}
            >
              Done
            </Button>
          </div>
        </Modal>
        <Modal
          open={isopennewupload}
          onCancel={() => {
            setNewDoc({
              ...newDoc,
              categoryId: null,
              description: null,
              file: null,
            });
            setisopennewupload(false);
          }}
          footer={(null, null)}
          width={"45vw"}
          style={{ top: "5vh" }}
        >
          <div className="myModal d-flex flex-column justify-content-center gap-3 px-3">
            <h1>Upload Documents</h1>
            <p>You can attach a PDF,DOCX ,MP4 ,MOV ,JPG or PNG file.</p>
            <div className="line" />

            <div style={{ marginLeft: "12px", fontWeight: "600" }}>
              Category
              <span
                style={{
                  fontSize: "17px",
                  marginBottom: "20px",
                  marginLeft: "3px",
                  color: "red",
                }}
              >
                *
              </span>
            </div>

            <Select
              style={{ marginTop: "-8px", marginLeft: "9px" }}
              onChange={(e) => {
                setNewDoc({ ...newDoc, categoryId: e });
              }}
            >
              {categoris.map((temp) => {
                return (
                  <Select.Option value={temp.id}>{temp.title}</Select.Option>
                );
              })}
            </Select>
            <CustomInput
              label={"Description"}
              fullWidth
              onChange={(e) => setNewDoc({ ...newDoc, description: e })}
            />
            <div style={{ marginLeft: "10px" }}>
              <FileUploader
                required
                handleChange={(file) => setNewDoc({ ...newDoc, file: file })}
                name="file"
                types={["JPG", "PNG", "PDF", "mp4", "mov", "document", "docx"]}
                maxSize={50}
                classes="up_doc"
              />
            </div>
            {privilage.indexOf(access.patientManegment.document.addDocument) >
              -1 && (
              <Button
                type="primary"
                className="col-3 mx-2"
                onClick={async () => {
                  if (newDoc.categoryId && newDoc.file) {
                    await addDocument();
                    await fetchService();
                  } else {
                    Modal.error({ title: "Please enter all information!" });
                  }
                }}
                loading={isLoading}
              >
                Done
              </Button>
            )}
          </div>
        </Modal>
        <Modal
          open={isopennewcomment}
          onCancel={() => setDefult({})}
          footer={null}
          closable={false}
          width={isMobile ? "90vw" : "65vw"}
          destroyOnClose
        >
          <AddComment
            isOpen={isopennewcomment}
            getComments={getComments}
            setIsOpen={setisopennewcomment}
            patients={[{ id: patientId }]}
            purchase={[
              {
                id: parseInt(serviceId),
                service: { title: serviceName },
                patient: {},
              },
            ]}
            defultComment={defult}
            setDefult={setDefult}
          />
        </Modal>

        <Modal
          open={isOpenTemplate}
          onCancel={() => setIsOpenTemplate(false)}
          footer={null}
          // closable={false}
          width={isMobile ? "90vw" : "65vw"}
          destroyOnClose
        >
          <div
            style={{
              textAlign: "center",
              fontWeight: "bold",
              fontSize: "30px",
            }}
          >
            Choose Email Template{" "}
          </div>
          <hr />
          <div
            style={
              isMobile
                ? { width: "87vw", padding: "0px 20px" }
                : { padding: "40px 40px" }
            }
          >
            <p
              style={{
                padding: "0px 0px 24px 0px",
                fontWeight: "700",
                fontSize: "20px",
              }}
            >
              Email Templates
            </p>

            <Table
              scroll={{ x: "auto" }}
              loading={isLoading}
              rowSelection={{
                type: "radio",
                onChange: (newSelectedRowKeys, record) => {
                  setSelectedTemplate(record[0].id);
                },
              }}
              dataSource={TemplateData.map((u) => {
                return { ...u, key: u.id };
              })}
              columns={columnsTemplate}
              pagination={{
                onChange: async (page) => {
                  await fetchEmailsTemplates(page);
                },
                // total: 50,
                pageSize: 15,
              }}
            />
          </div>
          <div style={{ textAlign: "center" }}>
            <Button
              type="primary"
              size="large"
              onClick={async () => {
                setIsLoading(true);
                await fetchEmailsTemplate(selectedTemplate);
                setIsOpenTemplate(false);
                setIsLoading(false);
              }}
            >
              Confirm
            </Button>
          </div>
        </Modal>

        {/* <Modal
          open={openTranslator}
          onCancel={() => setOpenTranslator(false)}
          footer={null}
          closable={false}
          width={isMobile ? "90vw" : "65vw"}
          destroyOnClose
        >
          <div className="d-flex flex-column gap-4 w-100 justify-content-center align-items-center">
            <h2 style={{ fontSize: "22px", fontWeight: "600" }}>
              Please choose the language
            </h2>
            <div style={{ textAlign: "center", width: "100%" }}>
              <Select
                onChange={(e) => {
                  setLang(e);
                }}
                style={{ width: "75%" }}
                options={langs}
              ></Select>
            </div>

            {lang && (
              <label>
                The cost of your selected interpreter is ${}
                
                {langs.filter((l) => {
                  return l.value == lang;
                })[0].price *
                  ((new Date(item.finishedAt).getTime() -
                    new Date(item.startedAt).getTime()) /
                    3600000)}
              </label>
            )}

            {showInterpreterButton ? (
              <Button
                onClick={() => {
                  navigator.clipboard.writeText(interpreterLink);
                  setInterpreterText(true);
                }}
              >
                {interpreterText ? "Copied" : "Copy Link"}
              </Button>
            ) : (
              <Button
                onClick={async () => {
                  if (lang) {
                    setIsLoading(true);
                    var res = await putData(
                      `patient/${patientId}/appointment/${item.id}/translator`,
                      { lang: lang.toLocaleLowerCase() }
                    );
                    if (res.status == 200) {
                      var res2 = await putData(
                        `patient/${patientId}/appointment/${item.id}/translator/pay`,
                        { method: "online" }
                      );
                      if (res2.status == 200) {
                        setShowInterpreterButton(true);
                        setInterpreterLink(res2.data.data.payment.checkoutUrl);
                      }
                    }
                    setIsLoading(false);
                  } else {
                    Modal.error({
                      title: "Please choose the language.",
                    });
                  }
                }}
                loading={isLoading}
              >
                Generate Link
              </Button>
            )}
          </div>
        </Modal> */}
      </>
    );
  }
};

export default Step;
